function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof2(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import styled, { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { darken } from "polished";
import Dropdown from "react-bootstrap/Dropdown";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { useRef, useEffect, Fragment as Fragment$1, createElement, Children, createContext, useCallback, useState, useContext } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import dayjs from "dayjs";
import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import Modal from "react-bootstrap/Modal";
import { Nav, Navbar } from "react-bootstrap";
import Table from "react-bootstrap/Table";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var _$keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    _$keys.push.apply(_$keys, symbols);
  }

  return _$keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GREY = {
  one: "#F5F7FA",
  two: "#E4E7EB",
  three: "#CCD2D8",
  four: "#9CA5B0",
  five: "#7D8793",
  six: "#646E7B",
  seven: "#55606C",
  eight: "#414C58",
  nine: "#353F4A",
  ten: "#002033"
};
var ORANGE = {
  one: "#FFE4D9",
  two: "#FFC8B2",
  three: "#FFAD8C",
  four: "#FF9165",
  five: "#FF763F",
  six: "#C54714"
};
var BLUE = {
  one: "#D1F2F7",
  two: "#A2E5EF",
  three: "#74D9E6",
  four: "#45CCDE",
  five: "#17BFD6",
  six: "#1CA1B5",
  seven: "#398F9E",
  focus: "#398F9E"
};
var YELLOW = {
  one: "#FFF6DB",
  two: "#FFEDB7",
  three: "#FFE494",
  four: "#FFDB70",
  five: "#FFD24C",
  six: "#BD9211"
};
var RED = {
  one: "#FAE4E4",
  two: "#F9D0D5",
  three: "#F29FAA",
  four: "#DC5A54",
  five: "#BD2D2E",
  six: "#7C1010"
};
var GREEN = {
  one: "#F2FCF6",
  two: "#D1F5E3",
  three: "#85D3B0",
  four: "#57A886",
  five: "#316959",
  six: "#103A2E"
};
var NHS = {
  light: "#E6F2F9",
  mid: "#007AC3",
  dark: "#193647"
};
var GRADES = {
  sho: "#7B61FF",
  spr: "#FF61E6",
  fy1: "#FF763F",
  fy2: "#FFC93F",
  con: "#3EC7F2"
};
var SHIFTS_NEW = {
  early: {
    one: "#E8F3CD",
    two: "#D4EC98",
    three: "#6E9905"
  },
  late: {
    one: "#EFDDF5",
    two: "#DFBAEC",
    three: "#AD3FE0"
  },
  twilight: {
    one: "#E7E8FF",
    throw: "#C7C9FD",
    three: "#050B99"
  },
  longDay: {
    one: "#F6E5D2",
    two: "#F9CE9E",
    three: "#EA7F02"
  },
  night: {
    one: "#CBD7E5",
    two: "#A4B4C8",
    three: "#002033"
  },
  oncall: {
    one: "#CDE9FE",
    two: "#94D2FF",
    three: "#0081DE"
  },
  mid: {
    one: "#C2F1E6",
    two: "#95E9D2",
    three: "#0FAC86"
  },
  night1: {
    one: "#C9E0F0",
    two: "#77ABDC",
    three: "#003F77"
  },
  night2: {
    one: "#DCC3F6",
    two: "#B08BD7",
    three: "#250049"
  }
};
var SHIFTS = {
  early1: "#E8F3CD",
  early2: "#D4EC98",
  early3: "#6E9905",
  late1: "#EFDDF5",
  late2: "#DFBAEC",
  late3: "#AD3FE0",
  twilight1: "#E7E8FF",
  twilight2: "#C7C9FD",
  twilight3: "#050B99",
  longDay1: "#F7E5D2",
  longDay2: "#F9CE9E",
  longDay3: "#EA7F02",
  night1: "#CBD7E5",
  night2: "#A4B4C8",
  night3: "#002033",
  oncall1: "#0081DE",
  oncall2: "#94D2FF",
  oncall3: "#CDE9FE"
};
var GLOBAL = {
  black: "#000000",
  white: "#FFFFFF",
  backgroundColor: GREY.one,
  borderGrey: GREY.three,
  borderGreyLight: GREY.two,
  blue: BLUE.five,
  darkBlue: GREY.ten,
  darkGreen: GREEN.four,
  fontDark: GREY.ten,
  fontGrey: GREY.five,
  fontGreyLight: GREY.four,
  fontRed: RED.four,
  red: RED.four
};

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  display: flex;\n  height: 100vh;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$d() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 32px;\n"]);

  _templateObject1$d = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: 440px;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1),\n    0px 0px 150px rgba(69, 204, 222, 0.7);\n  padding: 44px 60px;\n  position: relative;\n  z-index: 1;\n\n  svg {\n    max-height: 37px;\n  }\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n  bottom: 24px;\n  color: #fff;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  text-align: center;\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  cursor: pointer;\n  height: 22px;\n  position: relative;\n  top: -1px;\n  transition: all 150ms;\n  width: 22px;\n\n  ", ":focus + & {\n    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n  }\n\n  svg {\n    fill: none;\n    position: relative;\n    stroke: white;\n    stroke-width: 2px;\n    top: -1px;\n    visibility: ", ";\n  }\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 0;\n  opacity: 1;\n  user-select: none;\n\n  span {\n    cursor: pointer;\n    opacity: 0.5;\n  }\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 70px;\n  display: flex;\n  justify-content: space-between;\n  width: 55px;\n\n  a {\n    svg {\n      opacity: 0.5;\n    }\n\n    &:hover {\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  text-decoration: none;\n  top: 2px;\n\n  &:hover {\n    opacity: 1;\n  }\n"]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  text-decoration: none;\n  top: 36px;\n\n  &:hover {\n    svg g {\n      stroke: ", ";\n    }\n  }\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

var AuthWrapper = styled.div(_templateObject$f(), function (param) {
  var background = param.background;
  return background ? background : "transparent";
});
var AuthLogoWrapper = styled.div(_templateObject1$d());
var AuthContainer = styled.div(_templateObject2$b());
var AuthFormBackground = styled.div(_templateObject3$9());
var AuthCopyrightText = styled.div(_templateObject4$8());
var HiddenCheckbox$1 = styled.input.attrs({
  type: "checkbox"
})(_templateObject5$5());
var StyledCheckbox$1 = styled.div(_templateObject6$4(), function (param) {
  var isChecked = param.isChecked;
  return isChecked ? "#17BFD6" : "white";
}, function (param) {
  var isChecked = param.isChecked;
  return isChecked ? "#17BFD6" : "#ccd2d8";
}, HiddenCheckbox$1, function (param) {
  var isChecked = param.isChecked;
  return isChecked ? "visible" : "hidden";
});
var RememberMe = styled.label(_templateObject7$4());

var AuthRememberMe = function AuthRememberMe(param) {
  var isChecked = param.isChecked,
      style = param.style,
      onChange = param.onChange;
  return jsxs(RememberMe, {
    style: style,
    children: [jsx(HiddenCheckbox$1, {
      checked: isChecked,
      onChange: onChange
    }), jsx(StyledCheckbox$1, {
      isChecked: isChecked,
      children: jsx("svg", {
        viewBox: "0 0 24 24",
        children: jsx("polyline", {
          points: "20 6 9 17 4 12"
        })
      })
    }), jsx("span", {
      style: {
        marginLeft: 8
      },
      children: "Remember me"
    })]
  });
};

var SocialsDiv = styled(AuthCopyrightText)(_templateObject8$3());

var AuthSocials = function AuthSocials() {
  return jsxs(SocialsDiv, {
    children: [jsx("a", {
      href: "https://www.twitter.com/heypatchwork/",
      target: "_blank",
      rel: "noreferrer",
      children: jsx("svg", {
        width: "20",
        height: "17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          opacity: "1",
          d: "M20 1.95a8.49 8.49 0 01-2.36.64A4.13 4.13 0 0019.45.32a8.21 8.21 0 01-2.61 1 4.1 4.1 0 00-7 3.74A11.64 11.64 0 011.39.77a4.16 4.16 0 00-.55 2.07 4.09 4.09 0 001.82 3.41A4.05 4.05 0 01.8 5.74v.05a4.1 4.1 0 003.3 4 3.93 3.93 0 01-1.1.17 4.9 4.9 0 01-.77-.07 4.11 4.11 0 003.83 2.84A8.22 8.22 0 010 14.43a11.57 11.57 0 006.29 1.85A11.59 11.59 0 0018 4.6v-.53a8.43 8.43 0 002-2.12z",
          fill: "#fff"
        })
      })
    }), jsx("a", {
      href: "https://www.linkedin.com/company/heypatchwork/",
      target: "_blank",
      rel: "noreferrer",
      children: jsx("svg", {
        width: "20",
        height: "20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          opacity: "1",
          d: "M18.41 0H1.47A1.45 1.45 0 000 1.43v17.14A1.45 1.45 0 001.47 20h16.94a1.45 1.45 0 001.47-1.43V1.43A1.45 1.45 0 0018.41 0zM6.03 16.74h-3v-9h3v9zM4.53 6.48a1.56 1.56 0 010-3.12 1.57 1.57 0 110 3.12zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0010.79 11a1.999 1.999 0 00-.1.73v5h-3v-9h3V9a3 3 0 012.71-1.5c2 0 3.45 1.29 3.45 4.06v5.18z",
          fill: "#fff"
        })
      })
    })]
  });
};

var AuthForgotPassword = styled(Link).attrs({
  children: "Forgot Password?",
  to: "/forgot"
})(_templateObject9$3());
var EyeBtn = styled.div(_templateObject10$2(), GLOBAL.fontDark);

var AuthPasswordEye = function AuthPasswordEye(props) {
  return jsx(EyeBtn, _objectSpreadProps(_objectSpread({}, props), {
    children: jsxs("svg", {
      width: "21",
      height: "20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsxs("g", {
        opacity: ".5",
        clipPath: "url(#clip0)",
        stroke: "#7D8793",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [jsx("path", {
          d: "M1.333 10S4.668 3.333 10.5 3.333c5.834 0 9.167 6.667 9.167 6.667s-3.334 6.667-9.167 6.667S1.334 10 1.334 10z"
        }), jsx("path", {
          d: "M10.5 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        })]
      }), jsx("defs", {
        children: jsx("clipPath", {
          id: "clip0",
          children: jsx("path", {
            fill: "#fff",
            transform: "translate(.5)",
            d: "M0 0h20v20H0z"
          })
        })
      })]
    })
  }));
};

var Logo = function Logo() {
  return jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "268",
    height: "48",
    viewBox: "0 0 268 48",
    children: jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [jsxs("g", {
        children: [jsx("path", {
          fill: "#1E2D36",
          d: "M28.894.09c-5.042 0-5.321 5.454-5.321 5.454V23.63h13.372c0-12.778-3.01-23.54-8.051-23.54",
          transform: "translate(.957)"
        }), jsx("path", {
          fill: "#FFD24C",
          d: "M23.573 23.626v18.086s-.279 5.454-5.321 5.454S10.2 36.403 10.2 23.626h13.373z",
          transform: "translate(.957)"
        }), jsx("path", {
          fill: "#2BC0D4",
          d: "M47.113 28.957c0-5.042-5.453-5.32-5.453-5.32H23.573v13.372c12.777 0 23.54-3.01 23.54-8.052M23.573 23.636H5.486s-5.453.279-5.453 5.321 10.763 8.052 23.54 8.052V23.636z",
          transform: "translate(.957)"
        }), jsx("path", {
          fill: "#FF7F4D",
          d: "M0 18.315c0 5.042 5.453 5.321 5.453 5.321H23.54V10.263C10.763 10.263 0 13.273 0 18.315M23.55 23.636h18.087s5.453-.279 5.453-5.321-10.763-8.052-23.54-8.052v13.373z",
          transform: "translate(.957)"
        }), jsx("path", {
          fill: "#1E2D36",
          d: "M23.573 23.637v18.086s.279 5.453 5.32 5.453c5.043 0 8.052-10.762 8.052-23.54H23.573z",
          transform: "translate(.957)"
        }), jsx("path", {
          fill: "#FFD24C",
          d: "M23.574 23.636V5.55S23.295.097 18.253.097 10.2 10.859 10.2 23.637h13.373z",
          transform: "translate(.957)"
        })]
      }), jsx("g", {
        fill: "#1E2D36",
        children: jsx("path", {
          d: "M10.485 14.932c3.27 0 5.123-1.57 5.123-4.163 0-2.377-1.656-4.164-5.013-4.164H7.346v8.327h3.14zM0 0h12.055c7.826 0 11.292 4.643 11.292 10.943 0 7.063-4.709 10.55-11.859 10.55H7.346v10.224H0V0zM40.399 20.84c0-3.008-1.983-5.188-4.6-5.188-2.66 0-4.686 2.071-4.686 5.188 0 3.073 1.94 5.145 4.664 5.145 2.551 0 4.622-2.027 4.622-5.145zm6.714-10.964v21.842h-6.627v-2.355H40.4c-1.395 1.832-3.445 2.769-6.06 2.769-6.017 0-10.29-4.556-10.29-11.314 0-6.67 4.317-11.357 9.963-11.357 2.354 0 4.469.916 6.017 2.724h.087v-2.31h6.997zM51.638 24.85v-9.286h-2.464V9.875h2.464V3.862l6.975-1.704v7.717h5.297v5.69h-5.297v7.978c0 1.417.327 2.485 1.657 2.485.48 0 1.395-.153 2.158-.545l1.722 5.144c-1.504.85-3.052 1.504-6.104 1.504-3.727 0-6.408-2.332-6.408-7.28M76.532 32.153c-6.475 0-11.335-4.6-11.335-11.336 0-6.735 4.84-11.357 11.684-11.357 3.575 0 7.238 1.482 9.44 4.36l-4.666 3.989c-1.046-1.264-2.507-2.115-4.512-2.115-2.943 0-4.905 2.071-4.905 5.058 0 3.052 2.027 5.166 4.97 5.166 2.158 0 3.597-1.024 4.447-1.983l4.774 4.164c-1.875 2.245-5.298 4.054-9.897 4.054zM110.528 18.55v13.167h-6.976V20.25c0-3.51-1.155-4.555-3.618-4.555-2.464 0-4.077 1.613-4.077 5.014h-.022v11.008H88.86V1.892h6.976v10.512h.088c1.722-1.962 4.12-2.943 6.736-2.943 4.555 0 7.869 2.201 7.869 9.09zM144.471 9.875L137.081 31.717 131.261 31.717 127.882 19.553 127.816 19.553 124.503 31.717 118.682 31.717 111.293 9.875 118.247 9.875 121.822 21.581 121.909 21.581 125.135 9.875 130.607 9.875 133.855 21.603 133.942 21.603 137.539 9.875zM156.086 25.94c2.66 0 4.73-2.136 4.73-5.122 0-3.03-2.005-5.123-4.73-5.123-2.812 0-4.752 2.158-4.752 5.123 0 2.92 2.006 5.122 4.753 5.122zm0 6.213c-7.019 0-11.793-4.709-11.793-11.335 0-6.627 4.774-11.357 11.794-11.357 6.931 0 11.77 4.642 11.77 11.357 0 6.692-4.839 11.335-11.77 11.335zM183.342 9.46c.065 0 .174 0 .24.022v7.521c-.633-.043-1.287-.043-1.635-.043-3.314 0-5.014 2.092-5.014 4.948v9.809h-6.976V9.875h6.976v2.921h.087c1.657-2.18 3.924-3.335 6.322-3.335zM194.994 23.717L192.683 26.334 192.683 31.718 185.708 31.718 185.708 1.892 192.683 1.892 192.683 17.113 192.77 17.113 199.092 9.875 207.18 9.875 199.681 18.399 207.354 31.717 199.616 31.717 195.104 23.717z",
          transform: "translate(.957) translate(58.114 7.525)"
        })
      })]
    })
  });
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var SIZES = {
  buttonBorderRadius: "8px",
  inputFontSize: "14px",
  inputBorderRadius: "6px"
};

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  display: inline-flex;\n  font-size: ", ";\n  font-weight: 600;\n  height: 42px;\n  justify-content: center;\n  line-height: 1;\n  padding: ", ";\n  width: ", ";\n\n  &:hover {\n    background: ", ";\n    box-shadow: none;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$c() {
  var data = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  color: ", ";\n  display: inline-flex;\n  position: relative;\n  text-transform: capitalize;\n  top: ", ";\n"]);

  _templateObject1$c = function _templateObject1() {
    return data;
  };

  return data;
}

var DefaultButton = function DefaultButton(_param) {
  var action = _param.action,
      color = _param.color,
      fontSize = _param.fontSize,
      icon = _param.icon,
      text = _param.text,
      type = _param.type,
      width = _param.width,
      children = _param.children,
      props = _objectWithoutProperties(_param, ["action", "color", "fontSize", "icon", "text", "type", "width", "children"]);

  var Icon = icon;
  return jsxs(ButtonStyled$1, _objectSpreadProps(_objectSpread({
    onClick: action ? function () {
      return action();
    } : undefined,
    color: color,
    fontSize: fontSize,
    icon: icon,
    type: type,
    width: width
  }, props), {
    children: [icon && jsx(Icon, {
      style: {
        marginRight: 8
      },
      title: text
    }), jsx(ButtonSpan$1, {
      icon: icon,
      type: type,
      children: text
    }), children]
  }));
};

DefaultButton.propTypes = {
  action: PropTypes.func,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  icon: PropTypes.elementType,
  text: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string
};
var ButtonStyled$1 = styled.button.attrs(function (props) {
  return {
    color: props.color,
    fontSize: props.fontSize,
    icon: props.icon,
    type: props.type,
    width: props.width
  };
})(_templateObject$e(), function (props) {
  return props.type === "white" ? GLOBAL.white : props.type === "grey" ? GREY.two : props.color ? GLOBAL[props.color] : GLOBAL.blue;
}, function (props) {
  return props.type === "white" ? "".concat(GLOBAL.borderGreyLight) : "transparent";
}, SIZES.buttonBorderRadius, function (props) {
  return props.type === "grey" ? "none" : "0px 1px 2px rgba(0, 0, 0, 0.1)";
}, function (props) {
  return props.type === "white" ? GLOBAL.fontDark : props.type === "grey" ? GREY.seven : GLOBAL.white;
}, function (props) {
  return props.fontSize ? props.fontSize : "14px";
}, function (props) {
  return props.icon ? "10px 16px" : "12px 16px";
}, function (props) {
  return props.width === "full" ? "100%" : "auto";
}, function (props) {
  return darken(.05, props.type === "white" ? GLOBAL.white : props.type === "grey" ? GREY.two : props.color ? GLOBAL[props.color] : GLOBAL.blue);
});
var ButtonSpan$1 = styled.span.attrs(function (props) {
  return {
    icon: props.icon,
    type: props.type
  };
})(_templateObject1$c(), function (props) {
  return props.type === "white" ? GLOBAL.fontDark : props.type === "grey" ? GREY.seven : GLOBAL.white;
}, function (props) {
  return props.icon ? "1px" : "0";
});

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  height: 42px;\n  line-height: 1;\n  padding: 12px 16px;\n\n  &:active,\n  &:focus,\n  &:hover,\n  &.show {\n    background: ", " !important;\n    border: 1px solid ", " !important;\n    box-shadow: none !important;\n    color: ", " !important;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$b() {
  var data = _taggedTemplateLiteral(["\n  min-width: 150px;\n  padding: 0;\n"]);

  _templateObject1$b = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 12px 16px;\n  text-align: left;\n  width: 100%;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

var DefaultDropdown = function DefaultDropdown(param) {
  var buttonText = param.buttonText,
      children = param.children;
  return jsxs(Dropdown, {
    menualign: "right",
    children: [jsx(DropdownToggle, {
      children: buttonText
    }), jsx(DropdownMenu, {
      children: children
    })]
  });
};

var DropdownToggle = styled(Dropdown.Toggle)(_templateObject$d(), GLOBAL.white, GLOBAL.borderGreyLight, SIZES.buttonBorderRadius, GLOBAL.fontDark, darken(.05, GLOBAL.white), GLOBAL.borderGreyLight, GLOBAL.fontDark);
var DropdownMenu = styled(Dropdown.Menu)(_templateObject1$b());
var DropdownButton = styled.button(_templateObject2$a(), darken(.01, GLOBAL.white), GLOBAL.borderGrey);

function SvgCollab(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 28,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 28,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("rect", {
      x: 8.02,
      y: 1,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("rect", {
      x: 4.51,
      y: 4.409,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("rect", {
      x: 1,
      y: 8,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("path", {
      d: "M16.21 16.38v1.42a.542.542 0 0 1-.549.533H11.64v3.906a.542.542 0 0 1-.549.533H9.63a.542.542 0 0 1-.549-.533v-3.906H5.058a.542.542 0 0 1-.548-.533v-1.42c0-.293.247-.533.548-.533H9.08v-3.906c0-.293.247-.533.549-.533h1.462c.302 0 .549.24.549.533v3.906h4.021c.302 0 .549.24.549.533z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgIconAdmin(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      fill: "#314551",
      fillOpacity: .5,
      children: [jsx("path", {
        d: "M8.05 8.927a3.95 3.95 0 1 1 7.9 0v.44a3.95 3.95 0 0 1-7.9 0v-.44z"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.555 19.16A11.8 11.8 0 0 1 .148 12C.148 5.454 5.454.148 12 .148S23.852 5.454 23.852 12a11.8 11.8 0 0 1-2.707 7.539A11.828 11.828 0 0 1 12 23.852c-3.855 0-7.28-1.841-9.445-4.692zm1.763.44c1.098-1.895 4.19-4.09 7.682-4.09s6.804 2.415 7.682 4.088c1.763-1.673 3.292-5.142 3.292-7.6 0-6.06-4.913-10.973-10.974-10.973C5.94 1.026 1.026 5.939 1.026 12c0 2.457 1.529 5.926 3.292 7.6z"
      })]
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .148,
        y: .148,
        width: 23.704,
        height: 25.185,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconDashboard(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 17",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 17,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      opacity: .4,
      filter: "url(#a)",
      children: jsx("path", {
        d: "M15.84.623C7.56-2.017 0 4.103 0 12.023c0 1.08.12 3.12.48 4.32 0 .24.24.48.48.48h21.96c.24 0 .48-.24.6-.48.24-1.2.48-3.24.48-4.32 0-5.16-3.24-9.84-8.16-11.4zM12 2.423c.72 0 1.2.48 1.2 1.2s-.48 1.2-1.2 1.2-1.2-.48-1.2-1.2.48-1.2 1.2-1.2zm-8.4 10.8c-.72 0-1.2-.48-1.2-1.2s.48-1.2 1.2-1.2 1.2.48 1.2 1.2-.48 1.2-1.2 1.2zm3.36-6.24c-.48.48-1.2.48-1.68 0s-.48-1.32-.12-1.8c.48-.48 1.2-.48 1.68 0s.48 1.32.12 1.8zm5.04 7.44c-1.32 0-2.52-1.2-2.16-2.4.36-1.2 2.16-4.8 2.16-4.8s1.8 3.6 2.16 4.8c.36 1.2-.84 2.4-2.16 2.4zm6.84-7.44c-.48.48-1.2.48-1.68 0a1.16 1.16 0 0 1 0-1.68c.48-.48 1.2-.48 1.68 0 .36.36.36 1.2 0 1.68zm1.56 6.24c-.72 0-1.2-.48-1.2-1.2s.48-1.2 1.2-1.2 1.2.48 1.2 1.2-.48 1.2-1.2 1.2z",
        fill: "#fff"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: 0,
        y: 0,
        width: 24,
        height: 18.304,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconHub(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 17",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 27,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 17,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.507.852a2.1 2.1 0 0 0-2.1 2.1v11.356c0 1.16.94 2.1 2.1 2.1h21.727a2.1 2.1 0 0 0 2.1-2.1V2.951a2.1 2.1 0 0 0-2.1-2.099H2.507zm.75 6.138a.54.54 0 1 0 0 1.08h20.738a.54.54 0 1 0 0-1.08H3.258zm-.54 2.782a.54.54 0 0 1 .54-.54H20.79a.54.54 0 0 1 0 1.08H3.258a.54.54 0 0 1-.54-.54zm18.255 3.488a.54.54 0 1 0 0 1.08h3.133a.54.54 0 0 0 0-1.08h-3.133zm-18.071.54a.54.54 0 0 1 .54-.54h3.133a.54.54 0 1 1 0 1.08H3.44a.54.54 0 0 1-.54-.54zM23.897.852h-9.373v3.144c0 .421.342.763.764.763h7.846a.763.763 0 0 0 .763-.763V.852z",
        fill: "#45CCDE"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .407,
        y: .852,
        width: 25.926,
        height: 15.926,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconInstantPay(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 19,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      filter: "url(#a)",
      children: jsx("path", {
        d: "M10.417 1 1 12.3h8.475l-.942 7.533 9.417-11.3H9.475L10.417 1z",
        stroke: "#316959",
        strokeWidth: 1.883,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .058,
        y: .058,
        width: 18.833,
        height: 22.198,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconPassporting(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 16,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M6.274 4.375c-.313.84-.49 1.902-.54 2.974H4.037a4.028 4.028 0 0 1 2.237-2.974zm-.54 4.275c.05 1.073.227 2.136.54 2.976A4.028 4.028 0 0 1 4.037 8.65h1.697zm1.303 0h1.927c-.035 1.04-.362 2.91-.964 3.361-.604-.456-.927-2.316-.963-3.36zm1.556-3.574c.2.636.327 1.426.37 2.273H7.038C7.07 6.311 7.397 4.44 8 3.99c.084.048.349.312.593 1.087zm1.673 3.574h1.697a4.028 4.028 0 0 1-2.237 2.976c.313-.84.49-1.903.54-2.975zm1.697-1.3h-1.697c-.05-1.073-.227-2.136-.54-2.975a4.028 4.028 0 0 1 2.237 2.974z",
      fill: "#DC5A54"
    }), jsx("path", {
      d: "M14 0H0v20h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-4 16.65H6v-1.3h4v1.3zm-1.964-3.333C.938 13.078.943 2.92 8.036 2.683c7.009.333 7.003 10.304 0 10.634z",
      fill: "#DC5A54"
    })]
  }));
}

function SvgIconRoster(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        d: "M17.704.37H2.296A1.934 1.934 0 0 0 .37 2.298v15.407c0 1.058.867 1.926 1.926 1.926h15.408a1.933 1.933 0 0 0 1.926-1.926V2.297A1.932 1.932 0 0 0 17.704.37zM5.568 17.32h-2.95v-2.624h2.95v2.624zm0-3.505h-2.95v-2.623h2.95v2.623zM5.346 3.29a.817.817 0 1 1-.001-1.634.817.817 0 0 1 0 1.634zm4.159 14.03h-2.95v-2.624h2.95v2.624zm0-3.505h-2.95v-2.623h2.95v2.623zm0-3.502h-2.95V7.69h2.95v2.623zm-.322-7.841a.817.817 0 1 1 1.633 0 .817.817 0 0 1-1.633 0zm4.262 11.344h-2.95v-2.624h2.95v2.623zm0-3.503h-2.95V7.69h2.95v2.623zm.392-7.841a.817.817 0 1 1 1.634-.001.817.817 0 0 1-1.634 0zm3.546 11.344h-2.95v-2.624h2.95v2.623zm0-3.503h-2.95V7.69h2.95v2.623z",
        fill: "#FF9165"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .37,
        y: .371,
        width: 19.259,
        height: 19.63,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconSuperAdmin(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      filter: "url(#a)",
      fill: "#fff",
      children: [jsx("path", {
        opacity: .34,
        d: "M18.492 10.5c0-.388-.028-.777-.084-1.161l2.498-1.734-2.72-4.71-2.75 1.296a7.97 7.97 0 0 0-2.011-1.163L13.172 0H7.734L7.48 3.028a7.973 7.973 0 0 0-2.01 1.163L2.72 2.895 0 7.605 2.498 9.34a8.11 8.11 0 0 0 0 2.322L0 13.395l2.72 4.71 2.75-1.296a7.953 7.953 0 0 0 2.214 1.24v-2.705a5.593 5.593 0 0 1-1.93-1.838 5.56 5.56 0 0 1-.88-3.006 5.565 5.565 0 0 1 3.85-5.305l.806-.262v4.04l.923.74.923-.74v-4.04l.806.262a5.565 5.565 0 0 1 3.85 5.305 5.56 5.56 0 0 1-.88 3.006 5.591 5.591 0 0 1-1.93 1.838v2.705a7.95 7.95 0 0 0 2.214-1.24l2.75 1.296 2.72-4.71-2.498-1.734c.056-.384.084-.773.084-1.161z"
      }), jsx("path", {
        opacity: .7,
        d: "m11.991 14.586.348-.168a4.375 4.375 0 0 0 2.462-3.918c0-1.59-.854-3.018-2.195-3.78v2.845l-2.153 1.723L8.3 9.565V6.721A4.337 4.337 0 0 0 6.105 10.5c0 1.66.967 3.197 2.462 3.918l.348.168V21h3.076v-6.414z"
      })]
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: 0,
        y: 0,
        width: 20.906,
        height: 22.481,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconVms(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.388 8.613c-.192 0-.378.021-.56.056C2.103 4.063 5.954.371 10.63.371c4.675 0 8.526 3.692 8.801 8.298a2.924 2.924 0 0 0-.56-.056H17.7c-.215 0-.419.044-.61.115-.242-3.339-3.06-6.014-6.46-6.014-3.401 0-6.219 2.675-6.46 6.014a1.739 1.739 0 0 0-.61-.115H2.387zm0 8.242h1.171a.586.586 0 0 0 .586-.586v-5.898a.586.586 0 0 0-.586-.586H2.387c-.97 0-1.757.787-1.757 1.758v3.554c0 .97.787 1.758 1.757 1.758zm16.484-7.07H17.7a.586.586 0 0 0-.586.586v7.07a.586.586 0 0 1-.586.586h-3.037a1.755 1.755 0 0 0-1.65-1.172H9.458A1.76 1.76 0 0 0 7.7 18.613a1.76 1.76 0 0 0 1.758 1.758h2.383c.763 0 1.407-.492 1.65-1.172h3.037a1.76 1.76 0 0 0 1.758-1.758v-.586h.586c.97 0 1.758-.787 1.758-1.758v-3.554c0-.971-.787-1.758-1.758-1.758z",
        fill: "#FFD24C"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .63,
        y: .371,
        width: 20,
        height: 20.37,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgInfo(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM12 16v-4M12 8h.01",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgInputDate(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M19.778 22.905H4.222c-1.227 0-2.222-.98-2.222-2.19V5.38c0-1.21.995-2.19 2.222-2.19h2.222V1h2.223v2.19h6.666V1h2.223v2.19h2.222c1.227 0 2.222.981 2.222 2.191v15.333c0 1.21-.995 2.19-2.222 2.19zM4.222 9.762v10.952h15.556V9.762H4.222zm0-4.381v2.19h15.556v-2.19H4.222zm8.89 12.843a.3.3 0 0 1-.3.3h-1.623a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.622a.3.3 0 0 1 .3.3v1.59zm-4.445 0a.3.3 0 0 1-.3.3H6.744a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59zm8.889-4.381a.3.3 0 0 1-.3.3h-1.623a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59zm-4.445 0a.3.3 0 0 1-.3.3H11.19a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.622a.3.3 0 0 1 .3.3v1.59zm-4.444 0a.3.3 0 0 1-.3.3H6.744a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgPen(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M20 5.24a1.002 1.002 0 0 0-.29-.71L15.47.29a1.001 1.001 0 0 0-.71-.29 1 1 0 0 0-.71.29l-2.83 2.83L.29 14.05a1.001 1.001 0 0 0-.29.71V19a1 1 0 0 0 1 1h4.24a1.001 1.001 0 0 0 .76-.29L16.87 8.78 19.71 6a1.19 1.19 0 0 0 .22-.33c.01-.08.01-.16 0-.24a.697.697 0 0 0 0-.14l.07-.05ZM4.83 18H2v-2.83l9.93-9.93 2.83 2.83L4.83 18ZM16.17 6.66l-2.83-2.83 1.42-1.41 2.82 2.82-1.41 1.42Z",
      fill: "#7D8793"
    })]
  }));
}

function SvgPie(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M21.21 15.89A10 10 0 1 1 8 2.83",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M22 12A10 10 0 0 0 12 2v10h10Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgSearchLoupe(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M20.71 19.29 17 15.61A9 9 0 1 0 15.61 17l3.68 3.68a.999.999 0 0 0 1.42 0 1 1 0 0 0 0-1.39zM10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgSettings(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a1.998 1.998 0 0 1 0 2.83 1.998 1.998 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a1.998 1.998 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 3.417 1.415 2 2 0 0 1-.587 1.415l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1v0Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgToggle(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M16 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM16 5H8a7 7 0 0 0 0 14h8a7 7 0 1 0 0-14Zm0 12H8A5 5 0 0 1 8 7h8a5 5 0 1 1 0 10Z",
      fill: "#7D8793"
    })]
  }));
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  &:not(:last-child) {\n    margin-bottom: 28px;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$a() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: 16px !important;\n  font-weight: 450;\n  justify-content: flex-start;\n"]);

  _templateObject1$a = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  align-self: ", ";\n  cursor: ", ";\n  grid-column: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  position: relative;\n  textarea {\n    color: ", ";\n    display: flex;\n    height: auto;\n    line-height: 19px;\n    max-width: none;\n    width: 100%;\n  }\n  .DayPickerInput {\n    width: 100%;\n    input {\n      background-color: ", ";\n      border: 1px solid ", ";\n      border-radius: ", ";\n      border-bottom-left-radius: 0;\n      border-top-left-radius: 0;\n      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n      color: ", ";\n      font-size: ", ";\n      height: 42px;\n      line-height: 1;\n      padding: 0px 16px;\n      padding-left: 16px;\n      padding-right: 12px;\n      width: 100%;\n      ::placeholder {\n        color: ", ";\n      }\n      &:focus {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 4px 1px rgba(43, 192, 212, 0.5);\n        color: ", ";\n        outline: 0;\n      }\n    }\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-row-gap: 16px;\n  grid-template-columns: ", ";\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    display: ", " !important;\n    -ms-flex-wrap: ", " !important;\n    ", " {\n      -ms-flex: 300px !important;\n      margin-bottom: 16px !important;\n      margin-right: 30px !important;\n      width: ", " !important;\n    }\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  margin-bottom: 4px;\n  span {\n    color: ", ";\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  font-size: ", ";\n  font-weight: 400;\n  margin-top: 10px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  color: ", ";\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  line-height: 1;\n  padding: 11.5px 16px;\n  width: 100%;\n  ::placeholder {\n    color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 4px 1px rgba(43, 192, 212, 0.5);\n    color: ", ";\n    outline: 0;\n  }\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: nowrap;\n  .input-group-text {\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n    justify-content: center;\n    width: 50px;\n  }\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  margin-top: 10px;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  &:not(:last-child) {\n    margin-right: 24px;\n  }\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: ", ";\n  border-radius: 50%;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  height: 22px;\n  margin-right: 8px;\n  width: 22px;\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  float: right;\n  position: relative;\n  text-decoration: underline;\n  top: 2px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 6px;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  height: 22px;\n  position: relative;\n  top: -1px;\n  transition: all 150ms;\n  width: 22px;\n  ", ":focus + & {\n    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n  }\n  svg {\n    fill: none;\n    position: relative;\n    stroke: ", ";\n    stroke-width: 2px;\n    top: -1px;\n    visibility: ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0;\n  opacity: 1;\n  user-select: none;\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  border-top: 1px solid #ccd2d8;\n  height: 20px;\n  margin-top: 32px;\n  width: 100%;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

var FormGridContainer = function FormGridContainer(param) {
  var title = param.title,
      icon = param.icon,
      children = param.children,
      style = param.style;
  var SVG;
  if (icon === "collab") SVG = SvgCollab;
  if (icon === "info") SVG = SvgInfo;
  if (icon === "pen") SVG = SvgPen;
  if (icon === "settings") SVG = SvgSettings;
  if (icon === "toggle") SVG = SvgToggle;
  if (icon === "pie") SVG = SvgPie;
  return jsxs(FGWrap, {
    style: style,
    children: [title ? jsxs(FGTitle, {
      children: [icon ? jsx(SVG, {
        style: {
          paddingRight: 7
        }
      }) : null, title]
    }) : null, children]
  });
};

var FGWrap = styled.div(_templateObject$c());
var FGTitle = styled.p(_templateObject1$a());
var FormGroup = styled.div.attrs(function (props) {
  return {
    disabled: props.disabled
  };
})(_templateObject2$9(), function (param) {
  var alignSelf = param.alignSelf;
  return alignSelf ? alignSelf : null;
}, function (param) {
  var disabled = param.disabled;
  return disabled ? "not-allowed" : "auto";
}, function (param) {
  var gridColumn = param.gridColumn;
  return gridColumn ? gridColumn : null;
}, function (props) {
  return props.disabled ? "0.5" : "1";
}, function (param) {
  var disabled = param.disabled;
  return disabled ? "none" : "auto";
}, GLOBAL.fontDark, GLOBAL.white, GLOBAL.borderGrey, SIZES.inputBorderRadius, GLOBAL.fontDark, SIZES.inputFontSize, GLOBAL.fontGreyLight, GLOBAL.white, GREY.ten, GLOBAL.fontDark);
var FormGrid = styled.div.attrs(function (props) {
  return {
    columns: props.columns
  };
})(_templateObject3$8(), function (param) {
  var columnGap = param.columnGap;
  return columnGap ? "".concat(columnGap, "px") : "16px";
}, function (props) {
  return props.columns ? "repeat(".concat(props.columns, ", 1fr)") : "1";
}, function (param) {
  var columns = param.columns;
  return columns > 1 && "flex";
}, function (param) {
  var columns = param.columns;
  return columns > 1 && "wrap";
}, FormGroup, function (param) {
  var columns = param.columns;
  return columns === 1 ? "100%" : columns === 2 ? "340px" : "220px";
});
var FormLabel = styled(Form.Label)(_templateObject4$7(), SIZES.inputFontSize, GLOBAL.fontRed);
var FormErrorLabel = styled.span(_templateObject5$4(), GLOBAL.fontRed, SIZES.inputFontSize);
var FormText = styled(Form.Text)(_templateObject6$3(), GLOBAL.fontGreyLight);
var FormInput = styled(Form.Control)(_templateObject7$3(), GLOBAL.white, GLOBAL.borderGrey, SIZES.inputBorderRadius, GLOBAL.fontDark, GLOBAL.fontDark, SIZES.inputFontSize, function (param) {
  var height = param.height;
  return height ? height : "42px";
}, GLOBAL.fontGreyLight, GLOBAL.white, GREY.ten, GLOBAL.fontDark);
var FormInputGroup = styled(InputGroup).attrs(function (props) {
  return {
    width: props.width
  };
})(_templateObject8$2(), GLOBAL.backgroundColor, SIZES.inputBorderRadius);
var FormRadioButtonGroup = styled.div(_templateObject9$2());
var FormRadioButton = styled.button.attrs(function (props) {
  return {
    active: props.active
  };
})(_templateObject10$1(), function (props) {
  return props.active ? GLOBAL.fontDark : GLOBAL.fontGrey;
});
var FormRadioButtonIcon = styled.span.attrs(function (props) {
  return {
    active: props.active
  };
})(_templateObject11$1(), GLOBAL.white, function (props) {
  return props.active ? "8px solid ".concat(GREY.ten) : "1px solid ".concat(GLOBAL.borderGrey);
});
var FormSelectButton = styled.button(_templateObject12());
var HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
})(_templateObject13());
var StyledCheckbox = styled.div(_templateObject14(), function (param) {
  var isChecked = param.isChecked;
  return isChecked ? BLUE.two : GLOBAL.white;
}, function (param) {
  var isChecked = param.isChecked;
  return isChecked ? BLUE.five : GREY.three;
}, HiddenCheckbox, GREY.ten, function (param) {
  var isChecked = param.isChecked;
  return isChecked ? "visible" : "hidden";
});
var CheckboxWrap = styled.label(_templateObject15());

var FormCheckbox = function FormCheckbox(param) {
  var value = param.value,
      action = param.action,
      label = param.label,
      style = param.style,
      name = param.name;
  return jsxs(CheckboxWrap, {
    style: style,
    children: [jsx(HiddenCheckbox, {
      isChecked: value,
      onChange: action,
      name: name
    }), jsx(StyledCheckbox, {
      isChecked: value,
      name: name,
      children: jsx("svg", {
        viewBox: "0 0 24 24",
        children: jsx("polyline", {
          points: "20 6 9 17 4 12"
        })
      })
    }), jsx("span", {
      style: {
        marginLeft: 8
      },
      children: label
    })]
  });
};

var FormInputWithSymbol = function FormInputWithSymbol(_param) {
  var before = _param.before,
      after = _param.after,
      symbol = _param.symbol,
      props = _objectWithoutProperties(_param, ["before", "after", "symbol"]);

  return jsxs(InputGroup, {
    children: [after ? jsx(FormInput, _objectSpread({}, props)) : null, jsx(InputGroup.Prepend, {
      children: jsx(InputGroup.Text, {
        style: {
          borderRadius: "".concat(before ? "6px 0 0 6px" : "0px 6px 6px 0px")
        },
        children: symbol
      })
    }), before ? jsx(FormInput, _objectSpread({}, props)) : null]
  });
};

var FormBreak = styled.div(_templateObject16());

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  display: inline-flex;\n  flex-direction: column;\n  height: ", ";\n  justify-content: ", ";\n  padding: 5px 10px;\n  text-align: center;\n  width: ", ";\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$9() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject1$9 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: 60%;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 14px;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 24px;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  height: 24px;\n  position: relative;\n  width: 48px;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 25px;\n  box-shadow: ", ";\n  height: 16px;\n  left: ", ";\n  pointer-events: none;\n  position: absolute;\n  top: 3px;\n  transition: all 0.25s ease-in-out;\n  width: 16px;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

var FormToggle = function FormToggle(param) {
  var action = param.action,
      disabled = param.disabled,
      label = param.label,
      value = param.value,
      name = param.name,
      width = param.width;
  var hasLabel = !!label;
  return jsxs(ToggleContainer, {
    width: width,
    hasLabel: hasLabel,
    children: [hasLabel && jsx(TextContainer, {
      children: jsx(ToggleLabel, {
        children: label
      })
    }), jsx(ButtonContainer, {
      hasLabel: hasLabel,
      children: jsx(ToggleButton, {
        disabled: disabled,
        onClick: action,
        checked: value,
        name: name,
        children: jsx(ToggleButtonHandle, {
          checked: value
        })
      })
    })]
  });
};

var ToggleContainer = styled.div(_templateObject$b(), GLOBAL.backgroundColor, GLOBAL.borderGrey, SIZES.inputBorderRadius, function (param) {
  var hasLabel = param.hasLabel;
  return hasLabel ? "88px" : "42px";
}, function (param) {
  var hasLabel = param.hasLabel;
  return hasLabel ? "space-between" : "center";
}, function (param) {
  var width = param.width;
  return width ? width : "100%";
});
var ButtonContainer = styled.div(_templateObject1$9(), function (param) {
  var hasLabel = param.hasLabel;
  return hasLabel ? "40%" : undefined;
});
var TextContainer = styled.div(_templateObject2$8());
var ToggleLabel = styled.label(_templateObject3$7(), GREY.eight);
var ToggleButton = styled.button.attrs(function (props) {
  return {
    checked: props.checked
  };
})(_templateObject4$6(), function (props) {
  return props.checked ? GREEN.four : GLOBAL.white;
}, function (props) {
  return props.checked ? "transparent" : GLOBAL.borderGrey;
});
var ToggleButtonHandle = styled.div.attrs(function (props) {
  return {
    checked: props.checked
  };
})(_templateObject5$3(), function (props) {
  return props.checked ? GLOBAL.white : GREY.four;
}, function (props) {
  return props.checked ? "box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);" : "none";
}, function (props) {
  return props.checked ? "27px" : "3px";
});

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 16px;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$8() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  cursor: ", ';\n  display: inline-flex;\n  font-size: "14px";\n  font-weight: 400;\n  height: 42px;\n  justify-content: space-between;\n  line-height: 1;\n  padding: 0 15px;\n  width: 50%;\n\n  &:hover {\n    background: ', ";\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    margin-right: 16px;\n  }\n"]);

  _templateObject1$8 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  color: ", ";\n  display: flex;\n  display: inline-flex;\n  font-weight: ", ";\n  pointer-events: none;\n  position: relative;\n  text-transform: capitalize;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: ", ";\n  border-radius: 50%;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  display: flex;\n  height: 18px;\n  justify-content: center;\n  pointer-events: none;\n  width: 18px;\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 50%;\n  height: 4px;\n  pointer-events: none;\n  width: 4px;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function FormToggleButtons(param) {
  var text = param.text,
      input = param.input,
      action = param.action,
      name = param.name,
      disabledIndices = param.disabledIndices;
  return jsx(ToggleButtonsContainer, {
    children: text.map(function (value, index) {
      return jsxs(ButtonStyled, {
        onClick: action ? function (e) {
          return action(e, index);
        } : undefined,
        name: name,
        selected: input === index,
        disabled: disabledIndices === null || disabledIndices === void 0 ? void 0 : disabledIndices.includes(index),
        children: [jsx(ButtonSpan, {
          selected: input === index,
          children: value
        }), jsx(ButtonSelected, {
          selected: input === index,
          children: jsx(ButtonInside, {})
        })]
      }, index);
    })
  });
}

var ToggleButtonsContainer = styled.div(_templateObject$a());
var ButtonStyled = styled.button(_templateObject1$8(), function (param) {
  var selected = param.selected;
  return selected ? "".concat(BLUE.one) : "".concat(GREY.one);
}, function (param) {
  var selected = param.selected;
  return selected ? "1px solid ".concat(BLUE.two) : "1px solid ".concat(GLOBAL.borderGreyLight);
}, SIZES.buttonBorderRadius, function (param) {
  var onClick = param.onClick;
  return onClick ? "pointer" : "default !important";
}, function (param) {
  var selected = param.selected,
      onClick = param.onClick;

  if (onClick) {
    return selected ? "".concat(BLUE.two) : "".concat(GLOBAL.borderGreyLight);
  }

  return undefined;
});
var ButtonSpan = styled.span(_templateObject2$7(), function (param) {
  var selected = param.selected;
  return selected ? "".concat(GLOBAL.fontDark) : "".concat(GREY.seven);
}, function (param) {
  var selected = param.selected;
  return selected ? "600" : "400";
});
var ButtonSelected = styled.div(_templateObject3$6(), function (param) {
  var selected = param.selected;
  return selected ? "".concat(GLOBAL.blue) : "white";
}, function (param) {
  var selected = param.selected;
  return selected ? "transparent" : "1px solid  ".concat(GLOBAL.borderGreyLight);
});
var ButtonInside = styled.div(_templateObject4$5());

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px !important;\n  font-weight: 500;\n  margin-bottom: 6px;\n  padding: 0;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px !important;\n  span {\n    font-weight: 450;\n  }\n"]);

  _templateObject1$7 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px !important;\n  padding-left: 7px;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n  padding-top: 10px;\n  p {\n    font-size: 14px;\n    font-weight: 400;\n    margin-left: 5px;\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

var FormInfoBox = function FormInfoBox(param) {
  var inputBoolean = param.inputBoolean,
      title = param.title,
      date = param.date,
      checkbox = param.checkbox,
      action = param.action,
      inputName = param.inputName,
      freeText = param.freeText;
  return jsxs("div", {
    children: [jsx(Title, {
      children: title
    }), jsx(Text, {
      children: freeText ? freeText === null || freeText === void 0 ? void 0 : freeText.map(function (e, i) {
        return jsx("div", {
          children: e
        }, i);
      }) : jsxs(Fragment, {
        children: ["Joined: ", jsx("span", {
          children: date
        })]
      })
    }), jsx(LowerWrap, {
      children: inputBoolean !== undefined ? checkbox ? jsx(FormCheckbox, {
        label: "Activate Worker",
        value: inputBoolean,
        name: inputName,
        action: function action1() {
          return action(inputName);
        }
      }) : jsxs(Fragment, {
        children: [inputBoolean ? GreenLight : RedLight, inputBoolean ? jsx(ActivatedText, {
          children: "Activated"
        }) : jsx(ActivatedText, {
          children: "Deactivated"
        })]
      }) : null
    })]
  });
};

var Title = styled.p(_templateObject$9());
var Text = styled.div(_templateObject1$7());
var ActivatedText = styled.p(_templateObject2$6());
var LowerWrap = styled.div(_templateObject3$5());
var GreenLight = jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("circle", {
    cx: "7",
    cy: "7",
    r: "7",
    fill: "#57A886"
  })
});
var RedLight = jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("circle", {
    cx: "7",
    cy: "7",
    r: "7",
    fill: "#BD2D2E"
  })
});

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  color: #646e7b;\n  font-size: 14px !important;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding-right: 7px;\n"]);

  _templateObject1$6 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  padding-bottom: 12px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

var FormInfoText = function FormInfoText(param) {
  var text = param.text,
      style = param.style;
  return jsxs(InfoWrap, {
    style: style,
    children: [jsx(InfoSvg, {
      children: info
    }), jsx(InfoText, {
      children: text
    })]
  });
};

var InfoText = styled.p(_templateObject$8());
var InfoSvg = styled.div(_templateObject1$6());
var InfoWrap = styled.div(_templateObject2$5());
var info = jsxs("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsxs("g", {
    children: [jsx("path", {
      d: "M8.49967 15.3615C12.1816 15.3615 15.1663 12.3768 15.1663 8.69487C15.1663 5.01297 12.1816 2.0282 8.49967 2.0282C4.81778 2.0282 1.83301 5.01297 1.83301 8.69487C1.83301 12.3768 4.81778 15.3615 8.49967 15.3615Z",
      stroke: "#7D8793",
      strokeWidth: "1.33333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M8.5 11.3615V8.69482",
      stroke: "#7D8793",
      strokeWidth: "1.33333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M8.5 6.0282H8.50667",
      stroke: "#7D8793",
      strokeWidth: "1.33333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), jsx("defs", {
    children: jsx("clipPath", {
      id: "clip0",
      children: jsx("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0.5 0.694824)"
      })
    })
  })]
});

var customParseFormat = require("dayjs/plugin/customParseFormat");

dayjs.extend(customParseFormat);

function DateInput(param) {
  var value = param.value,
      name = param.name,
      action = param.action,
      width = param.width,
      JSDate = param.JSDate;
  var ref = useRef();

  var parseInputAndDisplay = function parseInputAndDisplay() {
    var parsed = dayjs(value, ["DD MM YYYY", "YYYY MM DD"]).toDate();
    var parsedJsDate = dayjs(value);
    if (dayjs(parsed).isValid()) return dayjs(parsed).format("DD/MM/YYYY");
    if (dayjs(parsedJsDate).isValid()) return dayjs(parsedJsDate).format("DD/MM/YYYY");
  };

  var handleClickOutside = function handleClickOutside(e) {
    if (!ref.current.input.parentElement.parentElement.contains(e.target)) {
      ref.current.hideDayPicker();
    }
  };

  useEffect(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return jsx("div", {
    style: width ? {
      width: width
    } : undefined,
    children: jsxs(FormInputGroup, {
      children: [jsx(FormInputGroup.Prepend, {
        style: {
          cursor: "pointer"
        },
        onClick: function onClick() {
          ref.current.showDayPicker();
        },
        children: jsx(FormInputGroup.Text, {
          children: jsx(SvgInputDate, {
            title: "Calender"
          })
        })
      }), jsx(DayPickerInput, {
        ref: ref,
        format: "DD/MM/YYYY",
        placeholder: "DD/MM/YYYY",
        parseDate: parseDate,
        formatDate: formatDate,
        value: parseInputAndDisplay(),
        onDayChange: function onDayChange(day) {
          return action(day, name, !!JSDate);
        },
        dayPickerProps: {
          firstDayOfWeek: 1
        }
      })]
    })
  });
}

var parseDate = function parseDate(str) {
  var parsed = dayjs(str, ["DD MM YYYY", "YYYY MM DD"]).toDate();
  if (dayjs(parsed).isValid()) return parsed;
};

var formatDate = function formatDate(date, format) {
  return dayjs(date).format(format);
};

var getCustomStyles = function getCustomStyles() {
  var selectStyle = {
    container: function container(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        width: "100%",
        "&.disabled": {
          pointerEvents: "none"
        }
      });
    },
    menuList: function menuList(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        paddingBottom: 0,
        paddingTop: 0
      });
    },
    indicatorSeparator: function indicatorSeparator(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        marginBottom: 10,
        marginTop: 10
      });
    },
    valueContainer: function valueContainer(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        padding: 0
      });
    },
    placeholder: function placeholder(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        color: GLOBAL.fontGreyLight,
        fontSize: SIZES.inputFontSize,
        maxWidth: "calc(100% - 3px)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      });
    },
    singleValue: function singleValue(base, _state) {
      return _objectSpreadProps(_objectSpread({}, base), {
        color: GLOBAL.fontDark,
        fontSize: SIZES.inputFontSize,
        textTransform: "capitalize",
        "&.disabled": {
          color: GLOBAL.fontDark
        }
      });
    },
    option: function option(base, _state) {
      return _objectSpread(_objectSpreadProps(_objectSpread({}, base), {
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: _state.isSelected ? BLUE.one : GLOBAL.backgroundColor
        },
        "&:not(:last-child)": {
          borderBottom: "1px solid ".concat(GLOBAL.borderGreyLight)
        },
        color: _state.isSelected ? GLOBAL.fontDark : undefined
      }), _state.isFocused && {
        backgroundColor: _state.isMulti ? undefined : "white"
      }, _state.isSelected && {
        backgroundColor: _state.isMulti ? undefined : GLOBAL.backgroundColor
      });
    },
    control: function control(base, _state) {
      return _objectSpread(_objectSpreadProps(_objectSpread({}, base), {
        appearance: "none",
        border: "1px solid ".concat(GLOBAL.borderGrey),
        borderRadius: SIZES.inputBorderRadius,
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        color: GLOBAL.fontDark,
        fontSize: SIZES.inputFontSize,
        minHeight: 42,
        paddingLeft: 12,
        width: "100%",
        "&:hover": {
          border: "1px solid ".concat(GLOBAL.borderGrey)
        },
        "&:active, &:focus": {
          border: "1px solid ".concat(GLOBAL.borderGrey),
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
          outline: "none"
        }
      }), _state.menuIsOpen && {
        backgroundColor: GLOBAL.white,
        boxShadow: "0px 0px 4px 1px rgba(43, 192, 212, 0.5)",
        color: GLOBAL.fontDark,
        outline: 0,
        border: "1px solid ".concat(GREY.ten),
        "&:hover": {
          border: "1px solid ".concat(GREY.ten)
        }
      });
    }
  };
  return selectStyle;
};

function FormSelect(props) {
  return jsx(Select, _objectSpread({
    className: "react-select-container",
    classNamePrefix: "react-select",
    styles: getCustomStyles()
  }, props));
}

function FormSelectAsync(props) {
  return jsx(AsyncSelect, _objectSpread({
    className: "react-select-container",
    classNamePrefix: "react-select",
    styles: getCustomStyles()
  }, props));
}

function FormSelectMulti(props) {
  return jsx(Select, _objectSpread({
    className: "react-select-container",
    classNamePrefix: "react-select",
    closeMenuOnSelect: false,
    components: {
      ValueContainer: CustomValueContainer,
      ClearIndicator: CustomClearIndicator
    },
    countLabel: props.countLabel,
    hideSelectedOptions: false,
    isMulti: true,
    styles: _objectSpreadProps(_objectSpread({}, getCustomStyles()), {
      clearIndicator: function clearIndicator(base, _state) {
        return _objectSpreadProps(_objectSpread({}, base), {
          cursor: "pointer",
          color: "black",
          fontSize: "12px",
          padding: "4px 10px",
          background: GREY.two,
          borderRadius: "6px",
          marginRight: "10px"
        });
      },
      option: function option(base, state) {
        return _objectSpreadProps(_objectSpread({}, base), {
          color: "black",
          fontWeight: state.isSelected ? "500" : "400",
          background: state.isSelected ? BLUE.one : "transparent",
          ":active": {
            background: BLUE.one
          },
          ":hover": {
            background: GREY.one
          },
          "&:not(:last-child)": {
            borderBottom: "1px solid ".concat(GLOBAL.borderGreyLight)
          }
        });
      }
    })
  }, props));
}

var ref, ref1;

var CustomValueContainer = function CustomValueContainer(_param) {
  var children = _param.children,
      selectProps = _param.selectProps,
      props = _objectWithoutProperties(_param, ["children", "selectProps"]);

  var ref2, ref3, ref4, ref5, ref6;
  return jsxs(components.ValueContainer, _objectSpreadProps(_objectSpread({
    selectProps: selectProps
  }, props), {
    children: [((ref2 = children[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.props) === null || ref3 === void 0 ? void 0 : ref3.children) ? jsx("div", {
      className: "react-select__placeholder",
      children: (ref4 = children[0]) === null || ref4 === void 0 ? void 0 : ref4.props.children
    }) : "".concat((ref = (ref5 = children[0]) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref !== void 0 ? ref : "0", " ").concat(((ref6 = children[0]) === null || ref6 === void 0 ? void 0 : ref6.length) === 1 ? (ref1 = selectProps === null || selectProps === void 0 ? void 0 : selectProps.countLabel) !== null && ref1 !== void 0 ? ref1 : "" : "".concat(selectProps.countLabel ? "".concat(selectProps.countLabel, "s") : ""), " Selected"), children[1]]
  }));
};

var CustomClearIndicator = function CustomClearIndicator(props) {
  var getStyles = props.getStyles,
      ref = props.innerProps.ref,
      restInnerProps = _objectWithoutProperties(props.innerProps, ["ref"]);

  return jsx("button", _objectSpreadProps(_objectSpread({
    type: "button"
  }, restInnerProps), {
    ref: ref,
    style: getStyles("clearIndicator", props),
    children: "Clear All"
  }));
};

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: ", ";\n  .react-select__multi-value {\n    background-color: ", ";\n    border-radius: 6px;\n    margin: 0;\n    padding: 8px 12px;\n    padding-right: ", ";\n    &__label {\n      color: ", ";\n      font-size: 14px;\n      font-weight: 600;\n      padding: 0;\n    }\n    &__remove {\n      background: transparent;\n      color: #fff;\n      cursor: pointer;\n      opacity: 0.5;\n      padding-left: 6px;\n      padding-right: 10px;\n      &:hover {\n        background: transparent;\n        color: #fff;\n        opacity: 1;\n      }\n    }\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

function FormSelectTags(props) {
  return jsx(Select, _objectSpread({
    isMulti: true,
    className: "react-select-container",
    classNamePrefix: "react-select",
    components: {
      SelectContainer: GetSelectContainer(),
      ValueContainer: GetValueContainer()
    },
    styles: _objectSpread({}, getCustomStyles(), props.tagsOnly && {
      control: function control() {
        return {
          display: "none"
        };
      },
      container: function container() {
        return {
          display: "none"
        };
      }
    }, props.viewOnly && {
      multiValueRemove: function multiValueRemove() {
        return {
          display: "none"
        };
      },
      control: function control() {
        return {
          display: "none"
        };
      }
    })
  }, props));
}

var SelectTagsContainer = styled.div(_templateObject$7(), function (props) {
  return props.viewOnly || props.tagsOnly ? "0" : "8px";
}, GREY.ten, function (props) {
  return props.viewOnly ? "12px" : "0px";
}, GLOBAL.white);

var GetSelectContainer = function GetSelectContainer() {
  var CustomSelectContainer = function CustomSelectContainer(props) {
    var ref, ref1;
    return jsxs(Fragment$1, {
      children: [jsx(components.SelectContainer, _objectSpread({}, props)), jsx(SelectTagsContainer, {
        viewOnly: (ref = props.selectProps) === null || ref === void 0 ? void 0 : ref.viewOnly,
        tagsOnly: (ref1 = props.selectProps) === null || ref1 === void 0 ? void 0 : ref1.tagsOnly,
        children: props.getValue().map(function (opt) {
          return /*#__PURE__*/createElement(components.MultiValue, _objectSpreadProps(_objectSpread({}, props), {
            components: {
              Container: components.MultiValueContainer,
              Label: components.MultiValueLabel,
              Remove: components.MultiValueRemove
            },
            key: props.selectProps.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return props.selectOption(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return props.selectOption(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            className: "react-select__multi-tag",
            isFocused: false
          }), props.selectProps.getOptionLabel(opt));
        })
      })]
    });
  };

  return CustomSelectContainer;
};

var GetValueContainer = function GetValueContainer() {
  var ValueContainer = function ValueContainer(_param) {
    var children = _param.children,
        props = _objectWithoutProperties(_param, ["children"]);

    var new_children = Children.map(children, function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === components.Input ? child : (child === null || child === void 0 ? void 0 : child.key) === "placeholder" ? jsx("div", {
        className: "react-select__placeholder",
        children: props.selectProps.placeholder
      }) : null;
    });
    return jsx(components.ValueContainer, _objectSpreadProps(_objectSpread({}, props), {
      children: new_children
    }));
  };

  return ValueContainer;
};

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-bottom-color: ", ";\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  padding: 24px 32px;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0;\n  text-transform: capitalize;\n\n  img {\n    border-radius: 50%;\n    height: 47px;\n    margin-right: 15px;\n    object-fit: contain;\n    width: 47px;\n  }\n\n  span {\n    font-weight: 400;\n    text-transform: lowercase;\n  }\n"]);

  _templateObject1$5 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 0;\n  padding: 0;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  padding: 32px;\n\n  p {\n    font-size: 18px;\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  margin-left: 32px;\n  margin-right: 32px;\n  min-height: 100px;\n  padding: 24px 0;\n\n  button {\n    &:not(:last-child) {\n      margin-right: 8px;\n    }\n  }\n\n  * {\n    margin: 0;\n\n    &:first-child {\n      max-width: 500px;\n    }\n  }\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: ", ";\n  width: 100%;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  background: #ff6c6c;\n  border: 1px solid #bd4848;\n  border-radius: 6px;\n  color: #ffffff;\n  padding: 10px 15px;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  background: rgba(139, 230, 138, 0.5);\n  border: 1px solid #338532;\n  border-radius: 6px;\n  color: #338532;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  padding: 10px 15px;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

var ModalHeader = styled(Modal.Header)(_templateObject$6(), GLOBAL.backgroundColor, GLOBAL.borderGrey);
var ModalTitle = styled(Modal.Title)(_templateObject1$5());
var StyledCloseButton = styled.button(_templateObject2$4());

var CloseButton = function CloseButton(props) {
  return jsx(StyledCloseButton, _objectSpreadProps(_objectSpread({}, props), {
    children: jsx("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsx("path", {
        d: "M18 6L6 18M6 6l12 12",
        stroke: "#7D8793",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })
  }));
};

var ModalBody = styled(Modal.Body)(_templateObject3$4());
var ModalFooter = styled(Modal.Footer)(_templateObject4$4(), GLOBAL.borderGrey);
var LoadingContainer = styled.div.attrs(function (props) {
  return {
    modal: props.modal
  };
})(_templateObject5$2(), function (props) {
  return props.modal === true ? "220px" : 0;
});
var ErrorContainer = styled.div(_templateObject6$2());
var SuccessContainer = styled.div(_templateObject7$2());

var Loading = function Loading(param) {
  var modal = param.modal,
      style = param.style;
  return jsx(LoadingContainer, {
    modal: modal,
    style: style,
    "data-testid": "loading-indicator",
    children: jsx("svg", {
      width: "38",
      height: "38",
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: GLOBAL.borderGrey,
      children: jsx("g", {
        fill: "none",
        fillRule: "evenodd",
        children: jsxs("g", {
          transform: "translate(1 1)",
          strokeWidth: "2",
          children: [jsx("circle", {
            strokeOpacity: ".5",
            cx: "18",
            cy: "18",
            r: "18"
          }), jsx("path", {
            d: "M36 18c0-9.94-8.06-18-18-18",
            children: jsx("animateTransform", {
              attributeName: "transform",
              type: "rotate",
              from: "0 18 18",
              to: "360 18 18",
              dur: "1s",
              repeatCount: "indefinite"
            })
          })]
        })
      })
    })
  });
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 12px;\n"]);

  _templateObject1$4 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border-radius: 4px;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: 13px;\n  font-weight: 400;\n  justify-content: space-between;\n  line-height: 1;\n  padding: 8px;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: ", ";\n    /* font-weight: 500; */\n    opacity: 1;\n    text-decoration: none;\n  }\n\n  span {\n    padding: 4px 0;\n    pointer-events: none;\n  }\n\n  &.active {\n    background: ", ";\n    color: ", ";\n    font-weight: 500;\n    opacity: 1;\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 0 0 0 16px;\n  flex-shrink: 0;\n  padding-top: 7px;\n  width: 180px;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column !important;\n  margin-left: -8px;\n  margin-right: -8px;\n  width: calc(100% + 16px);\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

var ModalNav = function ModalNav(param) {
  var menuItems = param.menuItems,
      buttonText = param.buttonText,
      onClick1 = param.onClick,
      page = param.page;
  return jsxs(NavWrapper, {
    children: [jsx(Navbar, {
      children: jsx(NavContainer, {
        children: menuItems.map(function (navItem) {
          return jsxs(NavBtn, {
            onClick: function onClick() {
              return onClick1(navItem.id);
            },
            className: page === navItem.id && "active",
            children: [jsx("span", {
              children: navItem.name
            }), navItem.alert && jsxs("svg", {
              width: "24",
              height: "24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [jsx("path", {
                d: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z",
                fill: "#DC5A54"
              }), jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
                fill: "#fff"
              })]
            })]
          }, navItem.id);
        })
      })
    }), buttonText && jsx(ButtonWrap, {
      children: jsx(DefaultButton, {
        action: function action1() {
          return console.log("click");
        },
        type: "white",
        text: buttonText
      })
    })]
  });
};

var ModalNavContainer = styled.div(_templateObject$5());
var ButtonWrap = styled.div(_templateObject1$4());
var NavBtn = styled.button(_templateObject2$3(), GREY.ten, GLOBAL.black, GREY.three, GLOBAL.black);
var NavWrapper = styled.div(_templateObject3$3(), GREY.two);
var NavContainer = styled(Nav)(_templateObject4$3());

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n\n  &:disabled {\n    background: ", ";\n    border: 0;\n    box-shadow: none;\n    opacity: 0.5;\n  }\n\n  &:not(:first-child) {\n    margin-left: 4px;\n  }\n\n  &:not(:last-child) {\n    margin-right: 4px;\n  }\n"]);

  _templateObject1$3 = function _templateObject1() {
    return data;
  };

  return data;
}

var Pagination = function Pagination(param) {
  var pageInfo = param.pageInfo,
      pagination = param.pagination,
      setPagination = param.setPagination;
  return jsxs(PaginationContainer, {
    children: [jsx(PaginationButton, {
      onClick: function onClick() {
        window.history.replaceState(null, null, "".concat(pagination.url, "?beforePage=").concat(pageInfo.startCursor));
        setPagination(function (pagination) {
          return _objectSpreadProps(_objectSpread({}, pagination), {
            after: undefined,
            before: pageInfo.startCursor,
            first: undefined,
            last: pagination.items
          });
        });
      },
      disabled: pageInfo.hasPreviousPage ? false : true,
      children: jsx("svg", {
        width: "8",
        height: "14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          d: "M7 13L1 7l6-6",
          stroke: "#9CA5B0",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    }), jsx(PaginationButton, {
      onClick: function onClick() {
        window.history.replaceState(null, null, "".concat(pagination.url, "?afterPage=").concat(pageInfo.endCursor));
        setPagination(function (pagination) {
          return _objectSpreadProps(_objectSpread({}, pagination), {
            after: pageInfo.endCursor,
            before: undefined,
            first: pagination.items,
            last: undefined
          });
        });
      },
      disabled: pageInfo.hasNextPage ? false : true,
      children: jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          d: "M9 6L15 12L9 18",
          stroke: "#9CA5B0",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    })]
  });
};

var PaginationContainer = styled.div(_templateObject$4());
var PaginationButton = styled.button(_templateObject1$3(), GLOBAL.white, GREY.two, GREY.three);
var SHADOWS = {};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n    word-wrap: break-word;\n  }\n\n  body,html {\n    color: ", ";\n    font-family: proxima-nova, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  body,button,html,input {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    background-color: ", ";\n  }\n\n  p {\n    line-height: 1.25;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n\n  h1,h2,h3,h4,h5 {\n    line-height: 1.2;\n  }\n\n  span {\n    display: inline;\n  }\n\n  a {\n    color: ", ";\n    font-weight: 600;\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  button {\n    background: transparent;\n    border: 0;\n    color: ", ";\n    padding: 0;\n    transition: 0.15s ease-in-out background-color, 0.15s ease-in-out box-shadow;\n\n    &:focus {\n      outline: none;\n    }\n  }\n  \n  select {\n    margin: 0;\n  }\n\n  .modal {\n    &-backdrop {\n      background: rgba(30,45,54,1);\n    }\n\n    &-content {\n      border-radius: 16px;\n      box-shadow: 0 8px 32px 0 rgba(0,0,0,0.22);\n    }\n\n    &-dialog {\n      @media only screen and (max-width: 768px) {\n        margin: 0.5rem 0 0;\n      }\n    }\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = createGlobalStyle(_templateObject$3(), GLOBAL.fontDark, GLOBAL.backgroundColor, GLOBAL.fontDark, GLOBAL.fontDark, GLOBAL.fontDark);

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n\n  h2 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n\n    span {\n      align-items: center;\n      background: ", ";\n      border-radius: 8px;\n      color: #646e7b;\n      display: inline-flex;\n      font-size: 16px;\n      font-weight: 600;\n      height: 32px;\n      justify-content: center;\n      margin-left: 10px;\n      margin-right: 6px;\n      min-width: 32px;\n      padding: 10px 6px;\n    }\n  }\n"]);

  _templateObject1$2 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 500px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  margin-top: -16px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 500px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  a {\n    color: ", ";\n  }\n\n  span {\n    color: ", ";\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  min-width: ", ";\n\n  &:not(:last-child) {\n    margin-right: 8px;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 8px;\n  display: flex;\n  height: 42px;\n  justify-content: center;\n  width: 42px;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n  margin-right: 24px;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  span {\n    color: ", ";\n    font-weight: 600;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-collapse: separate;\n  border-radius: 8px;\n  border-spacing: 0;\n  color: ", ";\n  overflow: hidden;\n\n  thead {\n    background: transparent;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n\n    th {\n      border-bottom: 0;\n      border-top: 0;\n      color: ", ";\n      font-size: 10px;\n      font-weight: 800;\n      letter-spacing: 0.5px;\n      padding-bottom: 10px;\n      padding-top: 10px;\n      text-transform: uppercase;\n      white-space: nowrap;\n    }\n  }\n\n  tbody {\n    tr {\n      th {\n        font-weight: 500;\n\n        a,\n        button {\n          font-weight: 500;\n          text-decoration: underline;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      td {\n        &.no-wrap {\n          white-space: nowrap;\n          width: 0.1%;\n        }\n\n        a {\n          color: ", ";\n          text-decoration: underline;\n\n          &:hover {\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n\n  td,\n  th {\n    border-color: ", ";\n    font-size: 14px;\n    overflow: hidden;\n    padding: 20px 24px;\n    vertical-align: middle;\n\n    button {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &:last-child {\n      text-align: right;\n    }\n\n    .logo {\n      background: ", ";\n      border-radius: 4px;\n      height: 48px;\n      margin-right: 16px;\n      object-fit: contain;\n      width: 48px;\n    }\n  }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 6px;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  font-size: ", ";\n  height: 42px;\n  max-width: 250px;\n  padding-left: 52px;\n  padding-right: 16px;\n  width: 100%;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 4px 1px rgba(43, 192, 212, 0.5);\n    color: ", ";\n    outline: 0;\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  color: ", ";\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n\n  &:not(:last-child) {\n    margin-right: 30px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

var _align;

var TableHeader = function TableHeader(param) {
  var buttons = param.buttons,
      headers = param.headers;
  return jsx("thead", {
    children: jsxs("tr", {
      children: [headers.map(function (header, index) {
        return jsx("th", {
          style: {
            textAlign: (_align = header.align) !== null && _align !== void 0 ? _align : "left"
          },
          children: header.title
        }, index);
      }), buttons && jsx("th", {})]
    })
  });
};

var TableHeaderContainer = styled.div(_templateObject$2());
var TableHeaderInner = styled.div(_templateObject1$2(), GREY.two);
var TableHeaderInnerTitle = styled.h2(_templateObject2$2());
var TableHeaderTopContainer = styled.div(_templateObject3$2());
var TableHeaderBreadCrumb = styled.div(_templateObject4$2(), GREY.seven, GREY.ten, GREY.four);
var TableHeaderInnerOption = styled.div.attrs(function (props) {
  return {
    minWidth: props.minWidth
  };
})(_templateObject5$1(), function (props) {
  return props.minWidth ? "".concat(props.minWidth, "px") : "auto";
});
var TableHeaderInnerButton = styled.button(_templateObject6$1(), GREY.two);
var TableHeaderInnerText = styled.p(_templateObject7$1(), GREY.seven, GREY.ten);
var FolderSVG = jsx("svg", {
  width: "43",
  height: "43",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M45.56 20.74C45.3718 20.508 45.1339 20.3211 44.864 20.193C44.594 20.065 44.2988 19.999 44 20H40V18C40 16.4087 39.3679 14.8826 38.2426 13.7574C37.1174 12.6322 35.5913 12 34 12H21.44L20.8 10C20.3851 8.82651 19.6155 7.81105 18.5978 7.09437C17.5801 6.37768 16.3647 5.99525 15.12 6.00004H8C6.4087 6.00004 4.88258 6.63219 3.75736 7.7574C2.63214 8.88262 2 10.4087 2 12V36C2 37.5913 2.63214 39.1175 3.75736 40.2427C4.88258 41.3679 6.4087 42 8 42H36.8C38.1624 41.9961 39.4829 41.5285 40.5443 40.6743C41.6057 39.8201 42.3448 38.6301 42.64 37.3L46 22.44C46.0608 22.1419 46.0528 21.8338 45.9766 21.5392C45.9003 21.2446 45.7578 20.9713 45.56 20.74ZM10.74 36.44C10.6384 36.8912 10.3836 37.2932 10.0189 37.5776C9.65428 37.8621 9.20232 38.0113 8.74 38H8C7.46957 38 6.96086 37.7893 6.58579 37.4143C6.21071 37.0392 6 36.5305 6 36V12C6 11.4696 6.21071 10.9609 6.58579 10.5858C6.96086 10.2108 7.46957 10 8 10H15.12C15.5561 9.97728 15.9877 10.0979 16.3489 10.3435C16.71 10.589 16.9808 10.9461 17.12 11.36L18.2 14.64C18.3283 15.0215 18.5688 15.3554 18.8899 15.5981C19.2111 15.8407 19.598 15.9808 20 16H34C34.5304 16 35.0391 16.2108 35.4142 16.5858C35.7893 16.9609 36 17.4696 36 18V20H16C15.5377 19.9887 15.0857 20.138 14.7211 20.4224C14.3564 20.7069 14.1016 21.1089 14 21.56L10.74 36.44ZM38.74 36.44C38.6384 36.8912 38.3836 37.2932 38.0189 37.5776C37.6543 37.8621 37.2023 38.0113 36.74 38H14.42C14.5233 37.7772 14.5972 37.5419 14.64 37.3L17.6 24H41.6L38.74 36.44Z",
    fill: "#9CA5B0"
  })
});
var WarningSVG = jsx("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M24 14C23.4696 14 22.9609 14.2107 22.5858 14.5858C22.2107 14.9609 22 15.4696 22 16V24C22 24.5304 22.2107 25.0391 22.5858 25.4142C22.9609 25.7893 23.4696 26 24 26C24.5304 26 25.0392 25.7893 25.4142 25.4142C25.7893 25.0391 26 24.5304 26 24V16C26 15.4696 25.7893 14.9609 25.4142 14.5858C25.0392 14.2107 24.5304 14 24 14ZM25.84 31.24C25.7962 31.1126 25.7357 30.9915 25.66 30.88L25.42 30.58C25.1388 30.3025 24.7816 30.1145 24.3936 30.0397C24.0057 29.965 23.6042 30.0068 23.24 30.16C22.9976 30.2613 22.7744 30.4033 22.58 30.58C22.3946 30.7669 22.248 30.9885 22.1485 31.2322C22.0489 31.4759 21.9985 31.7368 22 32C22.0032 32.2614 22.0575 32.5196 22.16 32.76C22.2498 33.0082 22.3931 33.2336 22.5798 33.4202C22.7664 33.6069 22.9918 33.7502 23.24 33.84C23.4794 33.9458 23.7383 34.0005 24 34.0005C24.2618 34.0005 24.5206 33.9458 24.76 33.84C25.0082 33.7502 25.2336 33.6069 25.4202 33.4202C25.6069 33.2336 25.7502 33.0082 25.84 32.76C25.9425 32.5196 25.9968 32.2614 26 32C26.0098 31.8668 26.0098 31.7332 26 31.6C25.9656 31.4725 25.9116 31.351 25.84 31.24ZM24 4C20.0444 4 16.1776 5.17298 12.8886 7.37061C9.59962 9.56824 7.03617 12.6918 5.52242 16.3463C4.00867 20.0009 3.6126 24.0222 4.3843 27.9018C5.15601 31.7814 7.06082 35.3451 9.85787 38.1421C12.6549 40.9392 16.2186 42.844 20.0982 43.6157C23.9778 44.3874 27.9992 43.9913 31.6537 42.4776C35.3082 40.9638 38.4318 38.4004 40.6294 35.1114C42.827 31.8224 44 27.9556 44 24C44 21.3736 43.4827 18.7728 42.4776 16.3463C41.4725 13.9198 39.9993 11.715 38.1421 9.85786C36.285 8.00069 34.0802 6.5275 31.6537 5.52241C29.2272 4.51732 26.6264 4 24 4ZM24 40C20.8355 40 17.7421 39.0616 15.1109 37.3035C12.4797 35.5454 10.4289 33.0466 9.21794 30.1229C8.00694 27.1993 7.69008 23.9823 8.30745 20.8786C8.92481 17.7749 10.4487 14.9239 12.6863 12.6863C14.9239 10.4487 17.7749 8.9248 20.8786 8.30744C23.9823 7.69007 27.1993 8.00693 30.1229 9.21793C33.0466 10.4289 35.5454 12.4797 37.3035 15.1109C39.0616 17.7421 40 20.8355 40 24C40 28.2435 38.3143 32.3131 35.3137 35.3137C32.3131 38.3143 28.2435 40 24 40Z",
    fill: "#9CA5B0"
  })
});
var LoadingSVG = jsx("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: GLOBAL.borderGrey,
  children: jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    children: jsxs("g", {
      transform: "translate(1 1)",
      strokeWidth: "2",
      children: [jsx("circle", {
        strokeOpacity: ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }), jsx("path", {
        d: "M36 18c0-9.94-8.06-18-18-18",
        children: jsx("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      })]
    })
  })
});

var TableContainer = function TableContainer(param) {
  var children = param.children,
      error = param.error,
      loading = param.loading,
      responsive = param.responsive,
      style = param.style;

  if (loading || error) {
    return jsx(TableContainerStyled, {
      style: style,
      responsive: responsive,
      children: jsxs(Fragment, {
        children: [children[0], loading ? jsx(InnerTableState, {
          icon: LoadingSVG
        }) : jsx(InnerTableState, {
          icon: WarningSVG,
          text1: "Something went wrong.",
          text2: "We’re working on it, and we’ll get it fixed as soon as possible."
        })]
      })
    });
  }

  if (children[1].props.children.length === 0) {
    return jsxs(TableContainerStyled, {
      style: style,
      responsive: responsive,
      children: [children[0], jsx(InnerTableState, {
        icon: FolderSVG,
        text1: "No results found.",
        text2: "Add new data, or try adjusting your search filter."
      })]
    });
  }

  return jsx(TableContainerStyled, {
    style: style,
    responsive: responsive,
    children: children
  });
};

var InnerTableState = function InnerTableState(param) {
  var icon = param.icon,
      text1 = param.text1,
      text2 = param.text2;
  return jsx("tbody", {
    children: jsx("tr", {
      children: jsx("td", {
        colSpan: 999,
        style: {
          padding: "0px"
        },
        children: jsxs("div", {
          style: {
            height: "312px",
            display: "flex",
            justifyContent: " center",
            flexDirection: "column",
            alignItems: "center",
            color: "#7D8793"
          },
          children: [icon, jsx("p", {
            style: {
              padding: 0,
              margin: 0,
              fontSize: 16,
              paddingTop: 10,
              fontWeight: 500,
              paddingBottom: 5
            },
            children: text1
          }), jsx("p", {
            children: text2
          })]
        })
      })
    })
  });
};

var TableContainerStyled = styled(Table).attrs(function (param) {
  var responsive = param.responsive;
  return {
    responsive: responsive === false ? false : true
  };
})(_templateObject8$1(), GLOBAL.white, GLOBAL.borderGrey, GLOBAL.fontDark, GLOBAL.fontGrey, GLOBAL.fontGrey, GLOBAL.fontDark, GLOBAL.borderGrey, GREY.two);

var TableSearchInput = function TableSearchInput(props) {
  return jsxs("div", {
    style: {
      position: "relative"
    },
    children: [jsx(SvgSearchLoupe, {
      style: {
        position: "absolute",
        top: 10.5,
        left: 15.5
      }
    }), jsx(StyledTableSearchInput, _objectSpread({}, props))]
  });
};

var StyledTableSearchInput = styled.input(_templateObject9$1(), GLOBAL.borderGrey, SIZES.inputFontSize, GLOBAL.fontGreyLight, GLOBAL.white, GREY.ten, GLOBAL.fontDark);
var TableEditButton = styled.button(_templateObject10(), GLOBAL.fontGrey);
var TableDeleteButton = styled(TableEditButton)(_templateObject11(), GLOBAL.fontRed);

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 8px;\n  box-shadow: 0px 12px 28px rgba(0, 32, 51, 0.15);\n  min-width: 250px;\n  padding: 16px;\n  padding-right: 20px;\n  position: absolute;\n  width: max-content;\n  z-index: 10;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1$1() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject1$1 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: ", ";\n  padding-right: 12px;\n\n  &:hover {\n    background: ", ";\n    border-radius: 8px;\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: ", ";\n  padding-right: 12px;\n\n  &:hover {\n    background: ", ";\n    border-radius: 8px;\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-size: ", ";\n  font-weight: 600;\n  padding-right: 12px;\n  width: 100%;\n\n  &:hover {\n    background: ", ";\n    border-radius: 8px;\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 8px;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin-right: 12px;\n  width: 40px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 8px;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin-right: 12px;\n  object-fit: contain;\n  width: 40px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 1px;\n  margin-bottom: 16px;\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

var DropdownMenuContainer = styled.div(_templateObject$1(), GLOBAL.white);
var DropdownMenuList = styled.ul(_templateObject1$1());
var DropdownMenuItem = styled.li(_templateObject2$1());
var DropdownMenuLink = styled(Link).attrs(function (props) {
  return {
    color: props.color,
    font: props.font
  };
})(_templateObject3$1(), SIZES.inputFontSize, function (props) {
  return props.color ? props.color : GLOBAL.backgroundColor;
}, function (props) {
  return props.font ? props.font : GLOBAL.darkBlue;
});
var DropdownMenuExternalLink = styled.a.attrs(function (props) {
  return {
    color: props.color,
    font: props.font
  };
})(_templateObject4$1(), SIZES.inputFontSize, function (props) {
  return props.color ? props.color : GLOBAL.backgroundColor;
}, function (props) {
  return props.font ? props.font : GLOBAL.darkBlue;
});
var DropdownMenuButton = styled.button.attrs(function (props) {
  return {
    color: props.color,
    font: props.font
  };
})(_templateObject5(), SIZES.inputFontSize, function (props) {
  return props.color ? props.color : GLOBAL.backgroundColor;
}, function (props) {
  return props.font ? props.font : GLOBAL.darkBlue;
});
var DropdownMenuIcon = styled.div.attrs(function (props) {
  return {
    color: props.color
  };
})(_templateObject6(), function (props) {
  return props.color ? props.color : GLOBAL.backgroundColor;
});
var DropdownMenuImage = styled.img(_templateObject7(), GREY.two);
var DropdownMenuHeader = styled.h5(_templateObject8(), GREY.five);
var DropdownSeperator = styled.div(_templateObject9(), GREY.two);

var findRosteringLink = function findRosteringLink(href) {
  if (href.includes("staging")) return "https://pw-rostering-staging.netlify.app";
  if (href.includes("demo")) return "https://roster-demo.patchwork.health";
  return "https://rota.patchwork.health/";
};

var findSuperhubLink = function findSuperhubLink(href) {
  if (href.includes("staging")) return "https://pw-superhub-staging.netlify.app";
  if (href.includes("demo")) return "https://superhub-demo.patchwork.health";
  return "https://superhub.patchwork.health";
};

var findBankLink = function findBankLink(href) {
  if (href.includes("staging")) return "https://api-test.patchwork.health";
  if (href.includes("demo")) return "https://api-demo.patchwork.health";
  return "https://api.patchwork.health";
};

var platformMenuItems = [{
  id: 0,
  name: "Rota",
  link: findRosteringLink(window.location.href),
  Icon: SvgIconRoster,
  color: ORANGE.one,
  external: true
}, {
  id: 1,
  name: "Bank",
  link: findBankLink(window.location.href),
  Icon: SvgIconHub,
  color: BLUE.one,
  external: true
}, {
  id: 2,
  name: "Agency",
  link: "https://vms.patchwork.health",
  Icon: SvgIconVms,
  color: YELLOW.one,
  external: true
}, {
  id: 3,
  name: "Admin",
  link: findSuperhubLink(window.location.href),
  Icon: SvgIconAdmin,
  color: GREY.two,
  external: true
}];
var startMenuItems = [{
  id: 0,
  name: "Patchwork Dashboard",
  link: "https://www.patchwork.health",
  Icon: SvgIconDashboard,
  color: GREY.six,
  font: GLOBAL.white,
  external: true
}];
var moreMenuItems = [{
  id: 0,
  name: "InstantPay",
  link: "https://www.patchwork.health/service/flexible-pay/",
  Icon: SvgIconInstantPay,
  color: GREEN.two,
  external: true
}, {
  id: 1,
  name: "Passporting",
  link: "https://www.patchwork.health",
  Icon: SvgIconPassporting,
  color: RED.one,
  external: true
}];
var patchworkMenuItems = [{
  id: 0,
  name: "SuperAdmin",
  link: findSuperhubLink(window.location.href),
  Icon: SvgIconSuperAdmin,
  color: GREY.ten,
  font: GLOBAL.white,
  external: true
}];

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self1 = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self1, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _typeof(obj) {
  "@swc/helpers - typeof";

  return obj && obj.constructor === Symbol ? "symbol" : _typeof2(obj);
}

var Op = Object.prototype;
var hasOwn = Op.hasOwnProperty;
var undefined$1;
var $Symbol = typeof Symbol === "function" ? Symbol : {};
var iteratorSymbol = $Symbol.iterator || "@@iterator";
var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

function wrap(innerFn, outerFn, self1, tryLocsList) {
  var protoGenerator = outerFn && _instanceof(outerFn.prototype, Generator) ? outerFn : Generator;
  var generator = Object.create(protoGenerator.prototype);
  var context = new Context(tryLocsList || []);
  generator._invoke = makeInvokeMethod(innerFn, self1, context);
  return generator;
}

function tryCatch(fn, obj, arg) {
  try {
    return {
      type: "normal",
      arg: fn.call(obj, arg)
    };
  } catch (err) {
    return {
      type: "throw",
      arg: err
    };
  }
}

var GenStateSuspendedStart = "suspendedStart";
var GenStateSuspendedYield = "suspendedYield";
var GenStateExecuting = "executing";
var GenStateCompleted = "completed";
var ContinueSentinel = {};

function Generator() {}

function GeneratorFunction() {}

function GeneratorFunctionPrototype() {}

var IteratorPrototype = {};

IteratorPrototype[iteratorSymbol] = function () {
  return this;
};

var getProto = Object.getPrototypeOf;
var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
  IteratorPrototype = NativeIteratorPrototype;
}

var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
GeneratorFunctionPrototype.constructor = GeneratorFunction;
GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

function defineIteratorMethods(prototype) {
  ["next", "throw", "return"].forEach(function (method) {
    prototype[method] = function (arg) {
      return this._invoke(method, arg);
    };
  });
}

function isGeneratorFunction(genFun) {
  var ctor = typeof genFun === "function" && genFun.constructor;
  return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
}

function mark(genFun) {
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
  } else {
    genFun.__proto__ = GeneratorFunctionPrototype;

    if (!(toStringTagSymbol in genFun)) {
      genFun[toStringTagSymbol] = "GeneratorFunction";
    }
  }

  genFun.prototype = Object.create(Gp);
  return genFun;
}

function awrap(arg) {
  return {
    __await: arg
  };
}

function AsyncIterator(generator, PromiseImpl) {
  var enqueue = function enqueue(method, arg) {
    function callInvokeWithMethodAndArg() {
      return new PromiseImpl(function (resolve, reject) {
        invoke(method, arg, resolve, reject);
      });
    }

    return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
  };

  function invoke(method, arg, resolve, reject) {
    var record = tryCatch(generator[method], generator, arg);

    if (record.type === "throw") {
      reject(record.arg);
    } else {
      var result = record.arg;
      var value = result.value;

      if (value && _typeof2(value) === "object" && hasOwn.call(value, "__await")) {
        return PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        });
      }

      return PromiseImpl.resolve(value).then(function (unwrapped) {
        result.value = unwrapped;
        resolve(result);
      }, function (error) {
        return invoke("throw", error, resolve, reject);
      });
    }
  }

  var previousPromise;
  this._invoke = enqueue;
}

defineIteratorMethods(AsyncIterator.prototype);

AsyncIterator.prototype[asyncIteratorSymbol] = function () {
  return this;
};

function async(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
  if (PromiseImpl === void 0) PromiseImpl = Promise;
  var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
  return isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
    return result.done ? result.value : iter.next();
  });
}

function makeInvokeMethod(innerFn, self1, context) {
  var state = GenStateSuspendedStart;
  return function invoke(method, arg) {
    if (state === GenStateExecuting) {
      throw new Error("Generator is already running");
    }

    if (state === GenStateCompleted) {
      if (method === "throw") {
        throw arg;
      }

      return doneResult();
    }

    context.method = method;
    context.arg = arg;

    while (true) {
      var delegate = context.delegate;

      if (delegate) {
        var delegateResult = maybeInvokeDelegate(delegate, context);

        if (delegateResult) {
          if (delegateResult === ContinueSentinel) continue;
          return delegateResult;
        }
      }

      if (context.method === "next") {
        context.sent = context._sent = context.arg;
      } else if (context.method === "throw") {
        if (state === GenStateSuspendedStart) {
          state = GenStateCompleted;
          throw context.arg;
        }

        context.dispatchException(context.arg);
      } else if (context.method === "return") {
        context.abrupt("return", context.arg);
      }

      state = GenStateExecuting;
      var record = tryCatch(innerFn, self1, context);

      if (record.type === "normal") {
        state = context.done ? GenStateCompleted : GenStateSuspendedYield;

        if (record.arg === ContinueSentinel) {
          continue;
        }

        return {
          value: record.arg,
          done: context.done
        };
      } else if (record.type === "throw") {
        state = GenStateCompleted;
        context.method = "throw";
        context.arg = record.arg;
      }
    }
  };
}

function maybeInvokeDelegate(delegate, context) {
  var method = delegate.iterator[context.method];

  if (method === undefined$1) {
    context.delegate = null;

    if (context.method === "throw") {
      if (delegate.iterator["return"]) {
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          return ContinueSentinel;
        }
      }

      context.method = "throw";
      context.arg = new TypeError("The iterator does not provide a 'throw' method");
    }

    return ContinueSentinel;
  }

  var record = tryCatch(method, delegate.iterator, context.arg);

  if (record.type === "throw") {
    context.method = "throw";
    context.arg = record.arg;
    context.delegate = null;
    return ContinueSentinel;
  }

  var info = record.arg;

  if (!info) {
    context.method = "throw";
    context.arg = new TypeError("iterator result is not an object");
    context.delegate = null;
    return ContinueSentinel;
  }

  if (info.done) {
    context[delegate.resultName] = info.value;
    context.next = delegate.nextLoc;

    if (context.method !== "return") {
      context.method = "next";
      context.arg = undefined$1;
    }
  } else {
    return info;
  }

  context.delegate = null;
  return ContinueSentinel;
}

defineIteratorMethods(Gp);
Gp[toStringTagSymbol] = "Generator";

Gp[iteratorSymbol] = function () {
  return this;
};

Gp.toString = function () {
  return "[object Generator]";
};

function pushTryEntry(locs) {
  var entry = {
    tryLoc: locs[0]
  };

  if (1 in locs) {
    entry.catchLoc = locs[1];
  }

  if (2 in locs) {
    entry.finallyLoc = locs[2];
    entry.afterLoc = locs[3];
  }

  this.tryEntries.push(entry);
}

function resetTryEntry(entry) {
  var record = entry.completion || {};
  record.type = "normal";
  delete record.arg;
  entry.completion = record;
}

function Context(tryLocsList) {
  this.tryEntries = [{
    tryLoc: "root"
  }];
  tryLocsList.forEach(pushTryEntry, this);
  this.reset(true);
}

function keys(object) {
  var _$keys = [];

  for (var key in object) {
    _$keys.push(key);
  }

  _$keys.reverse();

  return function next() {
    while (_$keys.length) {
      var key = _$keys.pop();

      if (key in object) {
        next.value = key;
        next.done = false;
        return next;
      }
    }

    next.done = true;
    return next;
  };
}

function values(iterable) {
  if (iterable) {
    var iteratorMethod = iterable[iteratorSymbol];

    if (iteratorMethod) {
      return iteratorMethod.call(iterable);
    }

    if (typeof iterable.next === "function") {
      return iterable;
    }

    if (!isNaN(iterable.length)) {
      var i = -1,
          next = function next() {
        while (++i < iterable.length) {
          if (hasOwn.call(iterable, i)) {
            next.value = iterable[i];
            next.done = false;
            return next;
          }
        }

        next.value = undefined$1;
        next.done = true;
        return next;
      };

      return next.next = next;
    }
  }

  return {
    next: doneResult
  };
}

function doneResult() {
  return {
    value: undefined$1,
    done: true
  };
}

Context.prototype = {
  constructor: Context,
  reset: function reset(skipTempReset) {
    this.prev = 0;
    this.next = 0;
    this.sent = this._sent = undefined$1;
    this.done = false;
    this.delegate = null;
    this.method = "next";
    this.arg = undefined$1;
    this.tryEntries.forEach(resetTryEntry);

    if (!skipTempReset) {
      for (var name in this) {
        if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
          this[name] = undefined$1;
        }
      }
    }
  },
  stop: function stop() {
    this.done = true;
    var rootEntry = this.tryEntries[0];
    var rootRecord = rootEntry.completion;

    if (rootRecord.type === "throw") {
      throw rootRecord.arg;
    }

    return this.rval;
  },
  dispatchException: function dispatchException(exception) {
    var handle = function handle(loc, caught) {
      record.type = "throw";
      record.arg = exception;
      context.next = loc;

      if (caught) {
        context.method = "next";
        context.arg = undefined$1;
      }

      return !!caught;
    };

    if (this.done) {
      throw exception;
    }

    var context = this;

    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];
      var record = entry.completion;

      if (entry.tryLoc === "root") {
        return handle("end");
      }

      if (entry.tryLoc <= this.prev) {
        var hasCatch = hasOwn.call(entry, "catchLoc");
        var hasFinally = hasOwn.call(entry, "finallyLoc");

        if (hasCatch && hasFinally) {
          if (this.prev < entry.catchLoc) {
            return handle(entry.catchLoc, true);
          } else if (this.prev < entry.finallyLoc) {
            return handle(entry.finallyLoc);
          }
        } else if (hasCatch) {
          if (this.prev < entry.catchLoc) {
            return handle(entry.catchLoc, true);
          }
        } else if (hasFinally) {
          if (this.prev < entry.finallyLoc) {
            return handle(entry.finallyLoc);
          }
        } else {
          throw new Error("try statement without catch or finally");
        }
      }
    }
  },
  abrupt: function abrupt(type, arg) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];

      if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
        var finallyEntry = entry;
        break;
      }
    }

    if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
      finallyEntry = null;
    }

    var record = finallyEntry ? finallyEntry.completion : {};
    record.type = type;
    record.arg = arg;

    if (finallyEntry) {
      this.method = "next";
      this.next = finallyEntry.finallyLoc;
      return ContinueSentinel;
    }

    return this.complete(record);
  },
  complete: function complete(record, afterLoc) {
    if (record.type === "throw") {
      throw record.arg;
    }

    if (record.type === "break" || record.type === "continue") {
      this.next = record.arg;
    } else if (record.type === "return") {
      this.rval = this.arg = record.arg;
      this.method = "return";
      this.next = "end";
    } else if (record.type === "normal" && afterLoc) {
      this.next = afterLoc;
    }

    return ContinueSentinel;
  },
  finish: function finish(finallyLoc) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];

      if (entry.finallyLoc === finallyLoc) {
        this.complete(entry.completion, entry.afterLoc);
        resetTryEntry(entry);
        return ContinueSentinel;
      }
    }
  },
  "catch": function _catch(tryLoc) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];

      if (entry.tryLoc === tryLoc) {
        var record = entry.completion;

        if (record.type === "throw") {
          var thrown = record.arg;
          resetTryEntry(entry);
        }

        return thrown;
      }
    }

    throw new Error("illegal catch attempt");
  },
  delegateYield: function delegateYield(iterable, resultName, nextLoc) {
    this.delegate = {
      iterator: values(iterable),
      resultName: resultName,
      nextLoc: nextLoc
    };

    if (this.method === "next") {
      this.arg = undefined$1;
    }

    return ContinueSentinel;
  }
};
var regeneratorRuntime = {
  wrap: wrap,
  isGeneratorFunction: isGeneratorFunction,
  AsyncIterator: AsyncIterator,
  mark: mark,
  awrap: awrap,
  async: async,
  keys: keys,
  values: values
};
var ct = Object.create,
    Ie = Object.defineProperty;
var mt = Object.getOwnPropertyDescriptor;
var dt = Object.getOwnPropertyNames;
var pt = Object.getPrototypeOf,
    ft = Object.prototype.hasOwnProperty;

var ht = function ht(t) {
  return Ie(t, "__esModule", {
    value: !0
  });
};

var vt = function vt(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};

var Tt = function Tt(t, e, n) {
  var _iteratorNormalCompletion = true,
      _didIteratorError = false,
      _iteratorError = undefined;
  if (e && _typeof2(e) == "object" || typeof e == "function") try {
    var _loop = function _loop() {
      var r = _step.value;
      !ft.call(t, r) && r !== "default" && Ie(t, r, {
        get: function get() {
          return e[r];
        },
        enumerable: !(n = mt(e, r)) || n.enumerable
      });
    };

    for (var _iterator = dt(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return t;
},
    It = function It(t) {
  return Tt(ht(Ie(t != null ? ct(pt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
    get: function get() {
      return t.default;
    },
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t);
};

var Ue = vt(function (ie, Fe) {
  (function (t, e) {
    _typeof2(ie) == "object" && typeof Fe != "undefined" ? e(ie) : typeof define == "function" && define.amd ? define(["exports"], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
  })(ie, function (t) {
    var e = function e(p) {
      return function (h) {
        var o = p(h);
        return h.add(o), o;
      };
    },
        n = function n(p) {
      return function (h, o) {
        return p.set(h, o), o;
      };
    },
        r = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER,
        a = 536870912,
        u = a * 2,
        b = function b(p, h) {
      return function (o) {
        var x = h.get(o),
            M = x === void 0 ? o.size : x < u ? x + 1 : 0;
        if (!o.has(M)) return p(o, M);

        if (o.size < a) {
          for (; o.has(M);) {
            M = Math.floor(Math.random() * u);
          }

          return p(o, M);
        }

        if (o.size > r) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");

        for (; o.has(M);) {
          M = Math.floor(Math.random() * r);
        }

        return p(o, M);
      };
    },
        W = new WeakMap(),
        ee = n(W),
        m = b(ee, W),
        c = e(m);

    t.addUniqueNumber = c, t.generateUniqueNumber = m, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  });
});
It(Ue());
var w = (typeof window == "undefined" ? "undefined" : typeof window === "undefined" ? "undefined" : _typeof(window)) == "object";
var T = {
  setTimeout: w ? setTimeout.bind(window) : setTimeout,
  clearTimeout: w ? clearTimeout.bind(window) : clearTimeout,
  setInterval: w ? setInterval.bind(window) : setInterval,
  clearInterval: w ? clearInterval.bind(window) : clearInterval
};

function ze(t) {
  T.setTimeout = t.setTimeout, T.clearTimeout = t.clearTimeout, T.setInterval = t.setInterval, T.clearInterval = t.clearInterval;
}

var Y = {},
    Xe = function () {
  function Xe(e) {
    _classCallCheck(this, Xe);

    this.closed = !1;
    this.mc = new MessageChannel();
    this.name = e, Y[e] = Y[e] || [], Y[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
  }

  var _proto = Xe.prototype;

  _proto.onStorage = function onStorage(e) {
    if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
    var n = JSON.parse(e.newValue);
    this.mc.port2.postMessage(n);
  };

  _proto.postMessage = function postMessage(e) {
    var _this = this;

    if (this.closed) throw new Error("InvalidStateError");
    var n = JSON.stringify(e),
        r = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
    window.localStorage.setItem(r, n), T.setTimeout(function () {
      window.localStorage.removeItem(r);
    }, 500), Y[this.name].forEach(function (a) {
      a !== _this && a.mc.port2.postMessage(JSON.parse(n));
    });
  };

  _proto.close = function close() {
    if (this.closed) return;
    this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
    var e = Y[this.name].indexOf(this);
    Y[this.name].splice(e, 1);
  };

  _proto.addEventListener = function addEventListener(e, n) {
    return this.mc.port1.addEventListener(e, n);
  };

  _proto.removeEventListener = function removeEventListener(e, n) {
    return this.mc.port1.removeEventListener(e, n);
  };

  _proto.dispatchEvent = function dispatchEvent(e) {
    return this.mc.port1.dispatchEvent(e);
  };

  _createClass(Xe, [{
    key: "onmessage",
    get: function get() {
      return this.mc.port1.onmessage;
    },
    set: function set(e) {
      this.mc.port1.onmessage = e;
    }
  }, {
    key: "onmessageerror",
    get: function get() {
      return this.mc.port1.onmessageerror;
    },
    set: function set(e) {
      this.mc.port1.onmessageerror = e;
    }
  }]);

  return Xe;
}(),
    $e = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : Xe;

function Ke() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  return new Promise(function (e) {
    return T.setTimeout(e, t);
  });
}

function ae() {
  return Math.random().toString(36).substring(2);
}

var l;

(function (o) {
  o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})(l || (l = {}));

var Ee = function () {
  function Ee(e, n) {
    _classCallCheck(this, Ee);

    this.token = ae();
    this.isLeader = !1;
    this.isDead = !1;
    this.isApplying = !1;
    this.reApply = !1;
    this.intervals = [];
    this.listeners = [];
    this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }

  var _proto = Ee.prototype;

  _proto.apply = function apply() {
    var _this = this;

    return _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
      var e, n;
      return _regeneratorRuntime().wrap(function _callee$(_ctx) {
        while (1) {
          switch (_ctx.prev = _ctx.next) {
            case 0:
              if (!(_this.isLeader || _this.isDead)) {
                _ctx.next = 2;
                break;
              }

              return _ctx.abrupt("return", !1);

            case 2:
              if (!_this.isApplying) {
                _ctx.next = 4;
                break;
              }

              return _ctx.abrupt("return", (_this.reApply = !0, !1));

            case 4:
              _this.isApplying = !0;
              e = !1, n = function n(r) {
                var _data = r.data,
                    a = _data.token,
                    u = _data.action;
                a !== _this.token && (u === l.APPLY && a > _this.token && (e = !0), u === l.TELL && (e = !0));
              };

              _this.channel.addEventListener("message", n);

              _ctx.prev = 7;

              _this.sendAction(l.APPLY);

              _ctx.next = 11;
              return Ke(_this.options.responseTime);

            case 11:
              _this.channel.removeEventListener("message", n);

              _this.isApplying = !1;
              return _ctx.abrupt("return", (_ctx.sent, e ? _this.reApply ? _this.apply() : !1 : (_this.assumeLead(), !0)));

            case 16:
              _ctx.prev = 16;
              _ctx.t0 = _ctx["catch"](7);
              return _ctx.abrupt("return", !1);

            case 19:
            case "end":
              return _ctx.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }))();
  };

  _proto.awaitLeadership = function awaitLeadership() {
    var _this = this;

    if (this.isLeader) return Promise.resolve();
    var e = !1,
        n = null;
    return new Promise(function (r) {
      var a = function a() {
        if (e) return;
        e = !0, T.clearInterval(n);

        var b = _this.intervals.indexOf(n);

        _this.intervals.splice(b, 1), _this.channel.removeEventListener("message", u), r();
      };

      n = T.setInterval(function () {
        _this.apply().then(function () {
          _this.isLeader && a();
        });
      }, _this.options.fallbackInterval), _this.intervals.push(n);

      var u = function u(b) {
        var _data = b.data,
            W = _data.action;
        W === l.CLOSE && _this.apply().then(function () {
          _this.isLeader && a();
        });
      };

      _this.channel.addEventListener("message", u);
    });
  };

  _proto.sendAction = function sendAction(e) {
    this.channel.postMessage({
      action: e,
      token: this.token
    });
  };

  _proto.assumeLead = function assumeLead() {
    var _this = this;

    this.isLeader = !0;

    var e = function e(n) {
      var _data = n.data,
          r = _data.action;
      r === l.APPLY && _this.sendAction(l.TELL);
    };

    return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(l.TELL);
  };

  _proto.waitForLeadership = function waitForLeadership() {
    return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
  };

  _proto.close = function close() {
    var _this = this;

    this.isDead || (this.isDead = !0, this.isLeader = !1, this.sendAction(l.CLOSE), this.listeners.forEach(function (e) {
      return _this.channel.removeEventListener("message", e);
    }), this.intervals.forEach(function (e) {
      return T.clearInterval(e);
    }));
  };

  return Ee;
}();

var k;

(function (r) {
  r[r.PROMPTED = 0] = "PROMPTED", r[r.ACTIVE = 1] = "ACTIVE", r[r.IDLE = 2] = "IDLE";
})(k || (k = {}));

var be = function () {
  function be(e) {
    var _this = this;

    _classCallCheck(this, be);

    this.token = ae();
    this.registry = new Map();
    this.allIdle = !1;
    var n = e.channelName;

    if (this.options = e, this.channel = new $e(n), this.registry.set(this.token, 1), e.leaderElection) {
      var r = {
        fallbackInterval: 2e3,
        responseTime: 100
      };
      this.elector = new Ee(this.channel, r), this.elector.waitForLeadership();
    }

    this.channel.addEventListener("message", function (r) {
      var _data = r.data,
          a = _data.action,
          u = _data.token,
          b = _data.data;

      switch (a) {
        case l.REGISTER:
          _this.registry.set(u, 2);

          break;

        case l.DEREGISTER:
          _this.registry.delete(u);

          break;

        case l.IDLE:
          _this.idle(u);

          break;

        case l.ACTIVE:
          _this.active(u);

          break;

        case l.PROMPT:
          _this.prompt(u);

          break;

        case l.START:
          _this.start(u);

          break;

        case l.RESET:
          _this.reset(u);

          break;

        case l.ACTIVATE:
          _this.activate(u);

          break;

        case l.PAUSE:
          _this.pause(u);

          break;

        case l.RESUME:
          _this.resume(u);

          break;

        case l.MESSAGE:
          _this.options.onMessage(b);

          break;
      }
    }), this.send(l.REGISTER);
  }

  var _proto = be.prototype;

  _proto.prompt = function prompt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.registry.set(e, 0);

    var n = _toConsumableArray(this.registry.values()).every(function (r) {
      return r === 0;
    });

    e === this.token && this.send(l.PROMPT), n && this.options.onPrompt();
  };

  _proto.idle = function idle() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.registry.set(e, 2);

    var n = _toConsumableArray(this.registry.values()).every(function (r) {
      return r === 2;
    });

    e === this.token && this.send(l.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
  };

  _proto.active = function active() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.allIdle = !1, this.registry.set(e, 1);

    var n = _toConsumableArray(this.registry.values()).some(function (r) {
      return r === 1;
    });

    e === this.token && this.send(l.ACTIVE), n && this.options.onActive();
  };

  _proto.start = function start() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.START) : this.options.start(!0);
  };

  _proto.reset = function reset() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.RESET) : this.options.reset(!0);
  };

  _proto.activate = function activate() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.ACTIVATE) : this.options.activate(!0);
  };

  _proto.pause = function pause() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    e === this.token ? this.send(l.PAUSE) : this.options.pause(!0);
  };

  _proto.resume = function resume() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
    e === this.token ? this.send(l.RESUME) : this.options.resume(!0);
  };

  _proto.message = function message(e) {
    try {
      this.channel.postMessage({
        action: l.MESSAGE,
        token: this.token,
        data: e
      });
    } catch (e1) {}
  };

  _proto.send = function send(e) {
    try {
      this.channel.postMessage({
        action: e,
        token: this.token
      });
    } catch (e1) {}
  };

  _proto.close = function close() {
    this.options.leaderElection && this.elector.close(), this.send(l.DEREGISTER), this.channel.close();
  };

  _createClass(be, [{
    key: "isLeader",
    get: function get() {
      if (!this.elector) throw new Error('❌ Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
      return this.elector.isLeader;
    }
  }]);

  return be;
}();

var Qe = w ? document : null,
    ge = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange"];

function F(t) {
  var e = useRef(t);
  return useEffect(function () {
    e.current = t;
  }, [t]), e;
}

function Ze(t, e) {
  var r = function r() {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    n && clearTimeout(n), n = setTimeout(function () {
      t.apply(void 0, _toConsumableArray(a)), n = null;
    }, e);
  };

  var n;
  return r.cancel = function () {
    clearTimeout(n);
  }, r;
}

function le(t, e) {
  var n = 0;
  return function () {
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }

    var a = new Date().getTime();
    if (!(a - n < e)) return n = a, t.apply(void 0, _toConsumableArray(r));
  };
}

var E = function E() {
  return w ? performance.now() : Date.now();
};

function $() {
  var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      tmp = ref.timeout,
      t = tmp === void 0 ? 1e3 * 60 * 20 : tmp,
      tmp1 = ref.promptTimeout,
      e = tmp1 === void 0 ? 0 : tmp1,
      tmp2 = ref.element,
      n = tmp2 === void 0 ? Qe : tmp2,
      tmp3 = ref.events,
      r = tmp3 === void 0 ? ge : tmp3,
      tmp4 = ref.timers,
      a = tmp4 === void 0 ? void 0 : tmp4,
      tmp5 = ref.immediateEvents,
      u = tmp5 === void 0 ? [] : tmp5,
      tmp6 = ref.onPrompt,
      b = tmp6 === void 0 ? function b() {} : tmp6,
      tmp7 = ref.onIdle,
      W = tmp7 === void 0 ? function W() {} : tmp7,
      tmp8 = ref.onActive,
      ee = tmp8 === void 0 ? function ee() {} : tmp8,
      tmp9 = ref.onAction,
      m = tmp9 === void 0 ? function m() {} : tmp9,
      tmp10 = ref.onMessage,
      c = tmp10 === void 0 ? function c() {} : tmp10,
      tmp11 = ref.debounce,
      d = tmp11 === void 0 ? 0 : tmp11,
      tmp12 = ref.throttle,
      p = tmp12 === void 0 ? 0 : tmp12,
      tmp13 = ref.eventsThrottle,
      h = tmp13 === void 0 ? 200 : tmp13,
      tmp14 = ref.startOnMount,
      o = tmp14 === void 0 ? !0 : tmp14,
      tmp15 = ref.startManually,
      x = tmp15 === void 0 ? !1 : tmp15,
      tmp16 = ref.stopOnIdle,
      M = tmp16 === void 0 ? !1 : tmp16,
      tmp17 = ref.crossTab,
      G = tmp17 === void 0 ? !1 : tmp17,
      tmp18 = ref.name,
      we = tmp18 === void 0 ? "idle-timer" : tmp18,
      tmp19 = ref.syncTimers,
      J = tmp19 === void 0 ? 0 : tmp19,
      tmp20 = ref.leaderElection,
      ye = tmp20 === void 0 ? !1 : tmp20;
  var q = useRef(E()),
      Le = useRef(Date.now()),
      te = useRef(E()),
      D = useRef(null),
      N = useRef(null),
      z = useRef(0),
      v = useRef(!0),
      A = useRef(!1),
      B = useRef(!0),
      X = useRef(!1),
      g = useRef(!1),
      y = useRef(0),
      R = useRef(0),
      O = useRef(null),
      s = useRef(null),
      C = F(t),
      re = F(e),
      et = F(M),
      ke = useRef(u),
      ce = useRef(n),
      me = useRef(_toConsumableArray(new Set(_toConsumableArray(r).concat(_toConsumableArray(u))).values())),
      xe = F(W),
      de = F(ee),
      Me = F(b),
      ne = F(c),
      L = useRef();
  useEffect(function () {
    L.current && L.current.cancel && L.current.cancel(), d > 0 ? L.current = Ze(m, d) : p > 0 ? L.current = le(m, p) : L.current = m;
  }, [m, p, d]);
  var Pe = useRef();
  useEffect(function () {
    G && J && (Pe.current = le(function () {
      s.current.active();
    }, J));
  }, [G, J]);

  var P = function P() {
    O.current !== null && (T.clearTimeout(O.current), O.current = null);
  },
      V = function V(i) {
    var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    P(), O.current = T.setTimeout(fe, i || C.current), S && (N.current = E());
  },
      Se = function Se(i) {
    y.current = 0, R.current = E(), g.current = !0, V(re.current, !1), Me.current(i);
  },
      Ae = function Ae() {
    P(), v.current = !0, D.current = E(), et.current ? H() : g.current && (R.current = 0, g.current = !1), xe.current();
  },
      pe = function pe(i) {
    P(), g.current = !1, R.current = 0, v.current = !1, z.current += E() - D.current, _(), V(), de.current(i);
  },
      fe = function fe(i) {
    if (!v.current) {
      if (L.current.cancel && L.current.cancel(), re.current > 0 && !g.current) {
        s.current ? s.current.prompt() : Se(i);
        return;
      }

      s.current ? s.current.idle() : Ae();
      return;
    }

    s.current ? s.current.active() : pe(i);
  },
      Re = function Re(i) {
    if (L.current(i), g.current) return;

    if (P(), !v.current && ke.current.includes(i.type)) {
      fe(i);
      return;
    }

    var S = E() - N.current;

    if (v.current && !M || !v.current && S > C.current) {
      fe(i);
      return;
    }

    A.current = !1, y.current = 0, R.current = 0, V(), G && J && Pe.current();
  },
      oe = useRef();

  useEffect(function () {
    var i = X.current;
    i && H(), h > 0 ? oe.current = le(Re, h) : oe.current = Re, i && _();
  }, [h, G, J]);

  var _ = function _() {
    !w || X.current || (me.current.forEach(function (i) {
      ce.current.addEventListener(i, oe.current, {
        capture: !0,
        passive: !0
      });
    }), X.current = !0);
  },
      H = function H() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    !w || (X.current || i) && (me.current.forEach(function (S) {
      ce.current.removeEventListener(S, oe.current, {
        capture: !0
      });
    }), X.current = !1);
  },
      j = useCallback(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, s.current && !i && s.current.start(), V();
  }, [O, v, C, s]),
      he = useCallback(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, q.current = E(), te.current = E(), s.current && !i && s.current.reset(), x || V();
  }, [O, v, C, x, s]),
      Oe = useCallback(function (i) {
    P(), _(), (v.current || g.current) && pe(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, te.current = E(), s.current && !i && s.current.activate(), V();
  }, [O, v, C, s]),
      ve = useCallback(function () {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return A.current ? !1 : (y.current = Ce(), A.current = !0, H(), P(), s.current && !i && s.current.pause(), !0);
  }, [O, s]),
      Te = useCallback(function () {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return A.current ? (A.current = !1, g.current || _(), v.current || V(y.current), R.current && (R.current = E()), s.current && !i && s.current.resume(), !0) : !1;
  }, [O, C, y, s]),
      tt = useCallback(function (i, S) {
    s.current ? (S && ne.current(i), s.current.message(i)) : S && ne.current(i);
  }, [c]),
      rt = useCallback(function () {
    return v.current;
  }, [v]),
      nt = useCallback(function () {
    return g.current;
  }, [g]),
      ot = useCallback(function () {
    if (!s.current) throw new Error('❌ Cross Tab feature is not enabled. To enable it set the "crossTab" property to true.');
    return s.current.isLeader;
  }, [s]),
      it = useCallback(function () {
    if (!s.current) throw new Error('❌ Cross Tab feature is not enabled. To enable it set the "crossTab" property to true.');
    return s.current.token;
  }, [s]),
      Ce = useCallback(function () {
    if (A.current) return y.current;

    var i = y.current ? y.current : re.current + C.current,
        S = N.current ? E() - N.current : 0,
        _e = Math.ceil(i - S);

    return _e < 0 ? 0 : Math.abs(_e);
  }, [C, re, g, y, N]),
      st = useCallback(function () {
    return Math.round(E() - te.current);
  }, [te]),
      De = useCallback(function () {
    return Math.round(E() - q.current);
  }, [q]),
      at = useCallback(function () {
    return D.current ? new Date(Le.current - q.current + D.current) : null;
  }, [D]),
      lt = useCallback(function () {
    return N.current ? new Date(Le.current - q.current + N.current) : null;
  }, [N]),
      Ne = useCallback(function () {
    return v.current ? Math.round(E() - D.current + z.current) : Math.round(z.current);
  }, [D, z]),
      ut = useCallback(function () {
    var i = Math.round(De() - Ne());
    return i >= 0 ? i : 0;
  }, [q, D, z]);

  return useEffect(function () {
    if (d > 0 && p > 0) throw new Error("❌ onAction can either be throttled or debounced, not both.");
    a && ze(a);

    var i = function i() {
      s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };

    return w && window.addEventListener("beforeunload", i), function () {
      w && window.removeEventListener("beforeunload", i), s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };
  }, []), useEffect(function () {
    s.current && s.current.close(), G ? s.current = new be({
      channelName: we,
      leaderElection: ye,
      onPrompt: function onPrompt() {
        Se();
      },
      onIdle: function onIdle() {
        Ae();
      },
      onActive: function onActive() {
        pe();
      },
      onMessage: ne.current,
      start: j,
      reset: he,
      activate: Oe,
      pause: ve,
      resume: Te
    }) : s.current = null;
  }, [G, we, ye, Me, xe, de, ne, j, he, ve, Te]), useEffect(function () {
    P(), H(!0), B.current || (A.current = !0, v.current = !0, y.current = 0), !x && (o ? j() : _());
  }, [x, o, B]), useEffect(function () {
    if (!B.current) {
      var i = _toConsumableArray(new Set(_toConsumableArray(r).concat(_toConsumableArray(u))).values());

      if (H(), me.current = i, ce.current = n, ke.current = u, x) return;
      o ? j() : _();
    }
  }, [n, JSON.stringify(r), JSON.stringify(u), B, x, o]), useEffect(function () {
    if (B.current) B.current = !1;else {
      if (C.current = t, x) return;
      v.current && (de.current(), s.current && s.current.active()), j();
    }
  }, [t, s, x, B, v]), {
    message: tt,
    start: j,
    reset: he,
    activate: Oe,
    pause: ve,
    resume: Te,
    isIdle: rt,
    isPrompted: nt,
    isLeader: ot,
    getTabId: it,
    getRemainingTime: Ce,
    getElapsedTime: st,
    getTotalElapsedTime: De,
    getLastIdleTime: at,
    getLastActiveTime: lt,
    getTotalIdleTime: Ne,
    getTotalActiveTime: ut
  };
}

var ue = /*#__PURE__*/createContext(null);
ue.Consumer;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  margin: auto;\n  max-width: max-content;\n  right: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _templateObject1() {
  var data = _taggedTemplateLiteral(["\n  max-width: 690px;\n\n  p {\n    font-size: 16px;\n  }\n"]);

  _templateObject1 = function _templateObject1() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n\n  b {\n    margin-right: 30px;\n  }\n\n  p {\n    font-size: 14px;\n    text-align: center;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 34px;\n  margin-right: 12px;\n  width: 21px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

var StyledModal = styled(Modal)(_templateObject());
var StyledModalBody = styled(ModalBody)(_templateObject1());
var StyledModalFooter = styled(ModalFooter)(_templateObject2());
var StyledRow = styled.div(_templateObject3());
var StyledIconWrapper = styled.div(_templateObject4());

var getHumanizedRemainingTime = function getHumanizedRemainingTime(timeMs) {
  var date = new Date(timeMs);
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var presentedMinutes = minutes >= 10 ? minutes : "0".concat(minutes);
  var presentedSeconds = seconds >= 10 ? seconds : "0".concat(seconds);
  return "".concat(presentedMinutes, ":").concat(presentedSeconds);
};

var updateDocumentTitle = function updateDocumentTitle(withCountdown, time) {
  var currentTitle = document.title.replace(/[0-9][0-9]:[0-9][0-9]/, "").trim();
  return withCountdown ? "".concat(time, " ").concat(currentTitle) : currentTitle;
};

var Icon = function Icon() {
  return jsxs("svg", {
    width: "152",
    height: "98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [jsxs("g", {
      "clip-path": "url(#a)",
      children: [jsx("path", {
        d: "m138.64 97.7101-4.341-13.0277s4.775 4.7484 4.775 8.6446l-.857-9.0099s2.449 3.2874 2.204 8.2793c-.245 4.992-1.781 5.1137-1.781 5.1137ZM45.4116 85.8478l-4.2369-12.7146s4.6603 4.6343 4.6603 8.4368l-.8364-8.7932s2.3899 3.2083 2.1509 8.0802c-.239 4.872-1.7379 4.9908-1.7379 4.9908Z",
        fill: "#E6E6E6"
      }), jsx("path", {
        d: "M111.542 91.715c.007 8.364-16.6746 5.7912-37.0973 5.8087-20.4227.0175-36.8525 2.6183-36.8597-5.7452-.0073-8.3639 16.6686-10.1973 37.0913-10.2148 20.4228-.0175 36.8587 1.7874 36.8657 10.1513Z",
        fill: "#E6E6E6"
      }), jsx("path", {
        d: "M152 97.5188H0v.3827h152v-.3827Z",
        fill: "#3F3D56"
      }), jsx("path", {
        d: "M97.2292 80.4196h-2.67l-1.2706-10.2409h3.9406v10.2409Z",
        fill: "#A0616A"
      }), jsx("path", {
        d: "M92.3556 79.661h5.4458v3.224H89.41v-.2949c0-.7768.3103-1.5219.8627-2.0712.5524-.5493 1.3017-.8579 2.0829-.8579Z",
        fill: "#2F2E41"
      }), jsx("path", {
        d: "M116.855 95.5345h-2.67l-1.271-10.2408h3.941v10.2408Z",
        fill: "#A0616A"
      }), jsx("path", {
        d: "M111.981 94.776h5.446V98h-8.392v-.2949c0-.7769.311-1.5219.863-2.0712.552-.5493 1.302-.8579 2.083-.8579Z",
        fill: "#2F2E41"
      }), jsx("path", {
        d: "M129.17 65.1108c.185-.2226.318-.4828.391-.7622.072-.2793.082-.5711.029-.8548-.053-.2837-.168-.5523-.337-.787-.169-.2347-.387-.4297-.64-.5713l-6.201-25.1201-3.965 1.6964 7.376 24.289c-.211.4381-.254.938-.119 1.4049.135.467.437.8685.85 1.1286s.907.3607 1.389.2826.919-.3293 1.227-.7061ZM124.334 14.3427c-.222-.2301-.491-.4091-.789-.5244-.299-.1154-.619-.1643-.939-.1433-.319.0211-.63.1115-.91.2649-.281.1535-.524.3662-.713.6233l-9.598 1.0957 1.46 3.6815 8.729-1.6246c.455.287 1 .3978 1.532.3117.532-.0862 1.014-.3635 1.354-.7792.341-.4158.516-.9413.492-1.4768-.023-.5355-.243-1.0439-.618-1.4288Z",
        fill: "#A0616A"
      }), jsx("path", {
        d: "m108.516 62.5057 4.189 31.2581 5.213-1.0672s-.767-22.7646 1.84-25.5089c2.606-2.7443-3.353-7.5519-3.353-7.5519l-7.889 2.8699Z",
        fill: "#2F2E41"
      }), jsx("path", {
        d: "m110.248 53.8959-1.924 2.8699s-14.8151-6.1223-14.8151 3.6353-.8478 16.3795-1.1545 16.8369c-.3066.4574 3.5475 1.6442 5.3874 1.3393 0 0 2.2702-15.7308 2.1164-16.6456 0 0 14.5328 7.0856 17.2928 6.4757 2.76-.6098 3.412-2.7687 3.872-3.9884.46-1.2197-.193-10.9057-.193-10.9057l-9.199-2.7916-1.383 3.1742Z",
        fill: "#2F2E41"
      }), jsx("path", {
        d: "m110.508 36.6648-.549-.6544s-6.142-13.7428-3.729-17.4512c2.413-3.7083 12.943-4.2537 13.272-4.0356.329.2182-.786 3.0503-.018 4.3592 0 0-8.157 1.7585-8.706 1.9767-.548.2181 4.227 8.2795 4.227 8.2795l-.549 4.9081-3.948 2.6177Z",
        fill: "#CCC"
      }), jsx("path", {
        d: "M121.257 29.9025s-5.704.6544-5.923.6544c-.22 0-.329-1.4179-.329-1.4179l-5.046 6.8714s-2.485 19.9347-1.827 19.6075c.658-.3272 12.796 1.552 12.905.6794.11-.8725-.109-5.2353.22-5.4535.329-.2181 5.703-13.7427 5.703-13.7427s-.548-2.8359-2.413-3.8175c-1.864-.9816-3.29-3.3811-3.29-3.3811Z",
        fill: "#CCC"
      }), jsx("path", {
        d: "m125.205 35.2469 1.755 1.8542s2.608 21.3063 1.182 21.9607c-1.426.6544-4.233.574-4.233.574l-2.762-10.1008 4.058-14.2881Z",
        fill: "#CCC"
      }), jsx("path", {
        d: "M115.776 28.5532c2.788 0 5.048-2.2476 5.048-5.0202s-2.26-5.0203-5.048-5.0203c-2.788 0-5.049 2.2477-5.049 5.0203 0 2.7726 2.261 5.0202 5.049 5.0202Z",
        fill: "#A0616A"
      }), jsx("path", {
        d: "M114.591 24.3163c-.068-1.0417-1.39-1.0774-2.439-1.0872-1.05-.0099-2.305.0274-2.899-.8333-.392-.5689-.317-1.3585.007-1.9684.324-.6099.857-1.0789 1.382-1.5301 1.355-1.165 2.751-2.3207 4.378-3.0664 1.626-.7456 3.533-1.0469 5.219-.4484 2.073.7353 4.874 4.5203 5.116 6.695.242 2.1746-.632 4.3914-2.105 6.0165-1.474 1.625-4.846.9693-6.968 1.5474 1.29-1.8156.44-5.1147-1.627-5.9625l-.064.6374Z",
        fill: "#2F2E41"
      }), jsx("path", {
        d: "M69.5971 89.2536c6.6934 0 12.1194-5.3957 12.1194-12.0517 0-6.6559-5.426-12.0516-12.1194-12.0516-6.6934 0-12.1195 5.3957-12.1195 12.0516 0 6.656 5.4261 12.0517 12.1195 12.0517ZM61.5035 64.294c-1.6797.0001-3.3234-.484-4.7322-1.3935-1.4087-.9096-2.5222-2.2057-3.2056-3.7315L34.3344 16.1025c-.637-1.4266-.9739-2.9676-.99-4.5284-.0161-1.5609.289-3.10847.8965-4.54774.6075-1.43926 1.5046-2.73977 2.6362-3.82159 1.1315-1.08182 2.4736-1.92209 3.9437-2.46916 1.4701-.547074 3.0372-.7893932 4.605-.712061 1.5677.077332 3.103.472681 4.5115 1.161741 1.4085.68907 2.6603 1.65729 3.6786 2.84515 1.0184 1.18787 1.7816 2.57028 2.2429 4.06226l13.9258 45.041c.3987 1.2893.4878 2.6535.26 3.9832-.2277 1.3296-.7658 2.5877-1.5711 3.673-.8054 1.0853-1.8555 1.9677-3.066 2.5763-1.2105.6085-2.5476.9263-3.904.9278Z",
        fill: "#17BFD6"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "a",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h152v98H0z"
        })
      })
    })]
  });
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === "undefined") {
    return;
  }

  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";

  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".timer-backdrop {\n  z-index: 1055 !important; /* default is 1040 */\n}\n\n.timer-backdrop + .fade.modal.show {\n  z-index: 1060 !important; /* default is 1050 */\n}\n";
styleInject(css_248z);
var defaultPromptTimeout = 5 * 6e4;
var defaultTimeout = 15 * 6e4;

var IdleTimer = function IdleTimer(param) {
  var onTimeout = param.onTimeout,
      logout = param.logout,
      promptTimeoutMs = param.promptTimeoutMs,
      timeoutMs = param.timeoutMs;
  var promptTimeout = promptTimeoutMs || defaultPromptTimeout;
  var timeout = timeoutMs || defaultTimeout;

  var ref = _slicedToArray(useState(false), 2),
      isModalVisible = ref[0],
      setIsModalVisible = ref[1];

  var ref1 = _slicedToArray(useState(""), 2),
      remainingTime = ref1[0],
      setRemainingTime = ref1[1];

  var onIdle = function onIdle() {
    return onTimeout();
  };

  var onPrompt = function onPrompt() {
    return setIsModalVisible(true);
  };

  var onMessage = function onMessage(param) {
    var isModalVisible = param.isModalVisible;
    document.title = updateDocumentTitle(false);
    setIsModalVisible(isModalVisible);
  };

  var ref2 = $({
    onIdle: onIdle,
    onMessage: onMessage,
    onPrompt: onPrompt,
    promptTimeout: promptTimeout,
    timeout: timeout,
    crossTab: true,
    syncTimers: 1
  }),
      reset = ref2.reset,
      getRemainingTime = ref2.getRemainingTime,
      message = ref2.message;

  var closeModalAndContinue = function closeModalAndContinue() {
    reset();
    document.title = updateDocumentTitle(false);
    message({
      isModalVisible: false
    });
    setIsModalVisible(false);
  };

  useEffect(function () {
    var interval = setInterval(function () {
      var remainingTimeMs = getRemainingTime();
      var time = getHumanizedRemainingTime(remainingTimeMs);
      setRemainingTime(time);

      if (remainingTimeMs < promptTimeout) {
        document.title = updateDocumentTitle(true, time);
      }

      if (time === "00:00") return clearInterval(interval);
    }, 1e3);
    return function () {
      return clearInterval(interval);
    };
  }, [getRemainingTime, promptTimeout]);
  return jsxs(StyledModal, {
    show: isModalVisible,
    onHide: closeModalAndContinue,
    size: "lg",
    backdropClassName: "timer-backdrop",
    centered: true,
    children: [jsx(ModalHeader, {
      children: jsx(ModalTitle, {
        children: "Session Timeout Warning"
      })
    }), jsxs(StyledModalBody, {
      children: [jsx("p", {
        children: "You haven't been active in awhile and your session is about to time-out. Would you like to remain logged in? You will lose any unsaved changes when the session times out."
      }), jsxs(StyledRow, {
        children: [jsxs("b", {
          children: ["Time remaining: ", remainingTime, " min"]
        }), jsx(Icon, {})]
      })]
    }), jsxs(StyledModalFooter, {
      children: [jsx(DefaultButton, {
        type: "white",
        onClick: function onClick() {
          return logout();
        },
        children: "Log Off"
      }), jsx(DefaultButton, {
        onClick: closeModalAndContinue,
        children: "Yes, I am still active"
      })]
    })]
  });
};

var IdleTimerContext = /*#__PURE__*/createContext({
  hasTimedOut: false,
  setHasTimedOut: function setHasTimedOut() {}
});

var AlertIcon = function AlertIcon() {
  return jsxs("svg", {
    width: "24",
    height: "25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [jsx("path", {
      d: "M10.29 4.44449 1.82002 18.5845c-.17463.3024-.26703.6453-.26801.9945-.00098.3492.0895.6926.26244.996.17293.3034.4223.5562.72328.7333.30098.1771.64309.2724.99229.2762H20.47c.3492-.0038.6913-.0991.9923-.2762.301-.1771.5504-.4299.7233-.7333.1729-.3034.2634-.6468.2624-.996-.0009-.3492-.0933-.6921-.268-.9945L13.71 4.44449c-.1782-.29389-.4293-.53688-.7288-.70551-.2995-.16864-.6374-.25723-.9812-.25723-.3437 0-.6816.08859-.9812.25723-.2995.16863-.5505.41162-.7288.70551Z",
      fill: "#FF763F"
    }), jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13 9.5845c0-.55228-.4477-1-1-1s-1 .44772-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4Zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1H12Z",
      fill: "#fff"
    })]
  });
};

var IdleTimerNotification = function IdleTimerNotification() {
  var ctx = useContext(IdleTimerContext);
  if (!ctx.hasTimedOut) return null;
  return jsxs(StyledRow, {
    children: [jsx(StyledIconWrapper, {
      children: jsx(AlertIcon, {})
    }), jsxs("p", {
      children: ["Your session timed out due to inactivity. ", jsx("br", {}), " Please sign in again."]
    })]
  });
};

export { AuthContainer, AuthCopyrightText, AuthForgotPassword, AuthFormBackground, AuthLogoWrapper, AuthPasswordEye, AuthRememberMe, AuthSocials, AuthWrapper, BLUE, ButtonStyled$1 as ButtonStyled, CloseButton, DateInput, DefaultButton, DefaultDropdown, DropdownButton, DropdownMenuButton, DropdownMenuContainer, DropdownMenuExternalLink, DropdownMenuHeader, DropdownMenuIcon, DropdownMenuImage, DropdownMenuItem, DropdownMenuLink, DropdownMenuList, DropdownSeperator, ErrorContainer, FormBreak, FormCheckbox, FormErrorLabel, FormGrid, FormGridContainer, FormGroup, FormInfoBox, FormInfoText, FormInput, FormInputGroup, FormInputWithSymbol, FormLabel, FormRadioButton, FormRadioButtonGroup, FormRadioButtonIcon, FormSelect, FormSelectAsync, FormSelectButton, FormSelectMulti, FormSelectTags, FormText, FormToggle, FormToggleButtons, GLOBAL, GRADES, GREEN, GREY, GlobalStyle, IdleTimer, IdleTimerContext, IdleTimerNotification, Loading, Logo, ModalBody, ModalFooter, ModalHeader, ModalNav, ModalNavContainer, ModalTitle, NHS, ORANGE, Pagination, RED, SHADOWS, SHIFTS, SHIFTS_NEW, SIZES, SuccessContainer, TableContainer, TableDeleteButton, TableEditButton, TableHeader, TableHeaderBreadCrumb, TableHeaderContainer, TableHeaderInner, TableHeaderInnerButton, TableHeaderInnerOption, TableHeaderInnerText, TableHeaderInnerTitle, TableHeaderTopContainer, TableSearchInput, YELLOW, moreMenuItems, patchworkMenuItems, platformMenuItems, startMenuItems };